export const WhiseLogo = (props) => {
    return (
        <svg
            viewBox="0 0 175 38"
            {...props}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="S70B" transform="translate(-100.000000, -103.000000)" fillRule="nonzero">
                    <g id="Logo" transform="translate(100.000000, 103.000000)">
                        <path
                            d="M147.764119,24.4489163 C147.682501,23.8943066 147.522257,23.3543032 147.288269,22.845355 C147.145076,22.5778905 146.960278,22.3351354 146.740861,22.1262693 C145.752054,21.1755554 144.419223,20.6727973 143.052125,20.7348383 L133.810607,20.7132657 C133.402616,20.7561355 132.995352,20.6257953 132.68717,20.3537228 C132.428865,19.9965047 132.310424,19.5562455 132.354432,19.1168953 L132.354432,17.9268083 C132.322176,17.528114 132.442455,17.1320673 132.690748,16.8194163 C133.000432,16.5500259 133.406511,16.4200649 133.814184,16.4598734 L145.341932,16.4598734 C146.207766,16.3412242 146.883974,15.4855121 146.883974,14.4428378 L146.883974,11.5053724 L132.214897,11.5053724 C131.209529,11.5449221 130.658544,11.5736855 129.946557,11.9116558 C129.680402,12.0555527 129.438836,12.2412603 129.230992,12.4617565 C128.284934,13.4554297 127.784637,14.7948189 127.846374,16.1686436 L127.846374,16.4670642 C127.846374,16.4670642 127.846374,17.160982 127.817752,18.1425341 L127.817752,18.1425341 C127.817752,19.5807056 127.85353,21.0188772 127.953709,21.8206578 C128.035327,22.3752676 128.195571,22.9152709 128.42956,23.4242191 C128.572752,23.6916837 128.75755,23.9344388 128.976967,24.1433049 C129.964333,25.0886328 131.292573,25.5885246 132.65497,25.527545 L135.599518,25.527545 L141.889333,25.5491176 C142.297323,25.5062477 142.704587,25.636588 143.012769,25.9086604 C143.271074,26.2658786 143.389515,26.7061377 143.345507,27.145488 L143.345507,28.3283841 C143.377763,28.7270784 143.257484,29.1231251 143.009191,29.4357762 C142.699507,29.7051665 142.293428,29.8351275 141.885755,29.795319 L130.644233,29.795319 C130.644233,29.795319 129.288237,31.9525764 128.579828,33.031205 C128.492394,33.1622691 128.433841,33.310597 128.408093,33.4662519 L128.408093,33.7826497 C128.508272,34.4082543 129.191636,34.9439732 130.114715,34.9547595 L143.19166,34.9547595 C144.078706,34.9402389 144.953691,34.7457921 145.764116,34.3830863 C146.030271,34.2391895 146.271837,34.0534818 146.47968,33.8329857 C147.425739,32.8393124 147.926035,31.4999232 147.864298,30.1260985 C147.864298,30.1260985 147.853565,25.225529 147.764119,24.4489163 Z"
                            id="Shape"
                            fill="#2768B1"
                        ></path>
                        <path
                            d="M122.096812,12.7709633 C122.073858,12.092778 121.540199,11.5440217 120.86604,11.5053724 L120.773017,11.5053724 C120.574357,11.5066873 120.378599,11.5534086 120.200565,11.6419987 C119.993051,11.7462661 117.427752,13.0154525 116.622742,13.4181405 L116.622742,34.925996 L120.558348,34.925996 C120.967917,34.925996 121.360505,34.7615347 121.648767,34.4691533 C121.937029,34.1767719 122.097053,33.7807417 122.093234,33.3691753 L122.096812,12.7709633 Z"
                            id="Shape"
                            fill="#2768B1"
                        ></path>
                        <path
                            d="M116.604852,8.15443268 C116.607296,8.49812424 116.747955,8.82621325 116.994835,9.06407618 C117.202506,9.26293228 117.468552,9.38904284 117.753334,9.42361907 L118.068182,9.42361907 C118.220039,9.40619046 118.367731,9.36239475 118.504677,9.29418363 C118.579811,9.25463391 121.774808,7.42456062 121.785541,7.41736976 L121.785541,6.32435938 C121.785541,6.29919138 121.785541,6.27761881 121.785541,6.25245081 C121.719082,5.37305958 120.977677,4.70077161 120.100386,4.72439354 L118.157628,4.72439354 C117.93176,4.71390041 117.707138,4.76351074 117.506464,4.86821069 C116.961658,5.1208308 116.611564,5.66747795 116.60843,6.27042795 L116.60843,8.15443268 L116.604852,8.15443268 Z"
                            id="Shape"
                            fill="#2768B1"
                        ></path>
                        <path
                            d="M109.191602,13.6626297 C108.817969,13.2000711 108.36325,12.810135 107.849918,12.5120925 C107.473467,12.3037705 107.076607,12.1350884 106.665658,12.0087324 C105.272305,11.5977173 103.824004,11.4060859 102.37227,11.4406547 L100.429511,11.4406547 C98.8338021,11.4658227 98.8338021,11.4658227 95.2989122,11.4406547 L95.2989122,4.21024721 C95.2831107,3.56703859 94.8032102,3.03136152 94.1683199,2.94825167 L93.8677827,2.94825167 C93.7182716,2.9659931 93.5729832,3.00979408 93.4384439,3.07768711 L89.8820871,4.89697412 L89.8820871,34.9188052 L93.9178723,34.9188052 C94.6758277,34.9148483 95.288189,34.2962604 95.2881788,33.5345651 L95.2881788,18.9586964 C95.2875595,18.8183018 95.3093013,18.6787121 95.3525796,18.5452221 C95.517752,17.9640814 95.839707,17.4401967 96.2828137,17.0315466 C96.8349975,16.6336203 97.5085109,16.4427855 98.186216,16.4922322 L102.361536,16.4922322 C103.570841,16.4922322 104.405666,16.7894543 104.866013,17.3838986 C105.326359,17.9783428 105.556533,18.8831924 105.556533,20.0984474 L105.556533,34.9116143 L109.746164,34.9116143 C110.087438,34.9125696 110.41506,34.7770012 110.656713,34.5348333 C110.898367,34.2926654 111.034182,33.9638098 111.034181,33.6208554 L111.034181,20.8355103 C111.057345,19.4389575 110.905891,18.0450093 110.583375,16.6863854 C110.341393,15.5895609 109.866657,14.558153 109.191602,13.6626297 Z"
                            id="Shape"
                            fill="#2768B1"
                        ></path>
                        <path
                            d="M78.297094,12.7709633 L73.8856374,29.694647 L69.7425175,16.9704243 C69.7425175,16.9704243 68.7729273,13.9179052 68.7335712,13.8280194 C68.5372056,13.3728827 68.1118699,13.0595267 67.620868,13.0082617 L63.4705925,13.0082617 C62.9857229,13.0637454 62.567079,13.3748196 62.3722007,13.824424 C62.3328446,13.9143097 57.2201345,29.694647 57.2201345,29.694647 L52.8051001,12.7709633 C52.5740538,12.0216741 51.8862206,11.5094453 51.1056338,11.5053724 L46.6762881,11.5053724 C46.6762881,11.5053724 52.6476758,33.3188393 52.6762984,33.3979388 C52.8659231,33.9839937 53.0591256,34.87566 53.7997351,34.87566 L58.8695113,34.87566 C59.7671927,34.9172403 60.5840607,34.3572777 60.8730925,33.5022062 L65.5528859,18.3366872 L70.2326793,33.4842291 C70.4938491,34.3525545 71.2979762,34.9402519 72.2004824,34.9224006 L77.3418151,34.9224006 C78.1432476,34.9224006 78.2577379,34.0990474 78.4545182,33.5022062 L84.4366395,11.5053724 L79.9965602,11.5053724 C79.2159735,11.5094453 78.5281403,12.0216741 78.297094,12.7709633 Z"
                            id="Shape"
                            fill="#2768B1"
                        ></path>
                        <g id="LOGOTYPE">
                            <path
                                d="M14.0608472,27.4906491 C13.1771247,24.8551998 12.0823107,19.7532862 11.6207714,17.0243557 C11.6207714,17.0243557 10.7263155,11.2429061 10.5474243,10.0060785 C10.3685331,8.76925101 10.5474243,7.37782004 9.05904962,6.05110679 C6.91951105,4.09519348 2.27549588,1.0211018 1.05545799,0.492573755 C-0.16457989,-0.0359542887 -0.0500895319,1.10020123 0.0715564741,2.23635676 C0.19320248,3.37251228 0.940967635,11.2644787 2.12164946,18.0238849 C3.30233128,24.7832912 5.1771109,28.2996206 5.97496559,29.7989145 C6.77282028,31.2982083 11.6207714,34.8325149 12.3613809,35.3286841 C13.1019904,35.8248533 14.7370558,37.0329174 15.6172005,36.3246179 C16.4973451,35.6163184 15.8640703,33.4698474 15.7710469,32.8873879 C15.6780235,32.3049284 14.9481474,30.1260985 14.0608472,27.4906491 Z"
                                id="Shape"
                                fill="#2768B1"
                            ></path>
                            <path
                                d="M26.1646248,28.4038881 C25.2809023,25.7684387 24.1860883,20.6665251 23.724549,17.9375946 C23.724549,17.9375946 22.8300931,12.156145 22.6512019,10.9193175 C22.4723107,9.68248995 22.6512019,8.29105897 21.1628272,6.96434572 C19.016133,5.02281413 14.3864291,1.94872245 13.1628134,1.4201944 C11.9391977,0.89166636 12.0536881,2.0170356 12.1646006,3.15678655 C12.2755131,4.2965375 13.0340118,12.1849084 14.2111158,18.9443147 C15.3882198,25.703721 17.2665772,29.2200504 18.0644319,30.7193443 C18.8622866,32.2186381 23.7102377,35.7529447 24.4508472,36.2491139 C25.1914567,36.7452831 26.8265221,37.9533472 27.7066668,37.2450477 C28.5868114,36.5367482 27.9535366,34.3902771 27.8605132,33.8078177 C27.7674898,33.2253582 27.0483472,31.0429329 26.1646248,28.4038881 Z"
                                id="Shape"
                                fill="#CF1327"
                            ></path>
                            <path
                                d="M37.4741255,24.06061 C36.1360194,20.2782188 35.9607061,19.3290256 34.3256406,17.7614186 C32.6905752,16.1938116 28.8623038,12.9219714 26.7120318,12.105809 C24.9481647,11.4370592 25.2343906,12.1669313 25.3238362,12.9219714 C25.4132818,13.6770114 25.6029064,14.7017087 25.6029064,14.7017087 C25.7853754,16.1398802 26.3792942,20.9146097 26.7299209,22.669179 C27.0805476,24.4237483 27.6887777,27.422336 29.0340394,28.989943 C30.3793011,30.55755 32.2111468,31.6182015 33.5635642,32.3336918 C34.9159815,33.0491822 37.7853962,34.4909492 38.4365601,34.7066749 C39.087724,34.9224006 39.5778858,34.3255594 39.4884402,33.0348005 C39.1598242,29.9759863 38.4839901,26.965005 37.4741255,24.06061 L37.4741255,24.06061 Z"
                                id="Shape"
                                fill="#CF1327"
                            ></path>
                        </g>
                        <path
                            d="M174.182885,20.8822509 L174.182885,19.9438439 C174.182885,19.9438439 174.182885,19.9438439 174.182885,19.9222714 C174.185523,19.1506399 174.138916,18.3796284 174.043234,17.614006 C173.982078,17.1173392 173.890067,16.6250027 173.767742,16.1398802 C173.551333,15.119423 173.100447,14.1639647 172.451103,13.3498274 C172.095527,12.9414804 171.679138,12.590963 171.216753,12.3107485 C170.870171,12.125484 170.505745,11.976105 170.129095,11.8649153 C169.055748,11.5053724 167.760576,11.5053724 166.193489,11.5053724 L161.22747,11.5053724 C159.79634,11.5053724 158.590614,11.5413267 157.595979,11.8649153 C157.216324,11.9802493 156.849461,12.1344634 156.501165,12.3251302 C156.043347,12.6029703 155.630671,12.9497713 155.277549,13.3534228 C154.631266,14.1672081 154.182881,15.1213283 153.968065,16.1398802 C153.84574,16.6250027 153.753729,17.1173392 153.692573,17.614006 C153.635328,18.0490529 153.59955,18.5092678 153.578083,18.9910553 L153.578083,19.1456587 L153.556616,19.9438439 L153.556616,19.9438439 L153.556616,30.0398082 C153.492627,31.4266002 154.001431,32.7783774 154.9627,33.7754588 C155.170764,33.9966897 155.412253,34.1835518 155.678265,34.3291549 C156.501849,34.6944354 157.389959,34.8900475 158.290076,34.9044235 L171.431423,34.9044235 C172.327112,34.8616918 173.020603,34.1005573 172.984198,33.2001902 L172.984198,29.820487 L160.018165,29.820487 C159.654851,29.835226 159.300286,29.7061282 159.030686,29.4609442 C158.797096,29.1516833 158.67816,28.7702322 158.69437,28.3823155 L158.69437,25.5311404 L172.844663,25.5311404 C173.598953,25.4172623 174.161388,24.7730528 174.175614,24.0066786 L174.175614,20.8822509 L174.182885,20.8822509 Z M169.120149,20.6809069 L158.601347,20.6809069 L158.601347,19.2643079 C158.601347,18.147328 158.813631,17.3167839 159.2382,16.7726757 C159.662768,16.2285674 160.434385,15.9553148 161.553052,15.9529179 L166.168444,15.9529179 C167.28711,15.9529179 168.058728,16.2261705 168.483296,16.7726757 C168.907865,17.3191809 169.120149,18.1497249 169.120149,19.2643079 L169.120149,20.6809069 Z"
                            id="Shape"
                            fill="#2768B1"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
};
export const MRSLogo = () => (
    <svg width="145" height="56" viewBox="0 0 145 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M62.5425 14.6924H68.5915C73.5516 14.6924 77.5737 10.6714 77.5737 5.7113H63.4281C60.639 5.7113 59.5841 5.98431 58.8616 6.1713C58.4854 6.26868 58.1993 6.34272 57.8053 6.34272C57.8053 6.34272 59.7819 8.54475 61.0718 10.8182C62.1267 12.6777 62.5425 14.6924 62.5425 14.6924ZM23.6757 6.33914C31.9736 6.33914 38.7004 13.1418 38.7004 21.5334V42.1877C38.7004 44.6423 36.7105 46.6322 34.2559 46.6322C31.8012 46.6322 29.8113 44.6423 29.8113 42.1877V21.5334C29.8113 18.1065 27.0643 15.3285 23.6757 15.3285C20.2871 15.3285 17.54 18.1065 17.54 21.5334V37.7431C17.54 42.6524 13.5603 46.6322 8.65094 46.6322V21.5334C8.65094 13.1418 15.3777 6.33914 23.6757 6.33914ZM49.5408 38.3422V30.6947C49.5408 30.6947 51.5315 32.6515 53.9853 33.9315C55.9115 34.9363 58.4299 35.176 58.4299 35.176V47.2315C53.5206 47.2315 49.5408 43.2515 49.5408 38.3422Z"
            fill="#2668B1"
        />
        <path
            d="M45.1832 5.78998C51.9617 5.78998 57.2923 11.0813 58.2815 17.8629L58.3983 18.664C58.677 20.5751 60.2987 21.991 62.209 21.991H74.742C81.6803 21.991 87.3049 27.679 87.3049 34.6955C87.3049 41.7121 81.6803 47.4001 74.742 47.4001H64.2377C64.2377 42.4354 68.2624 38.4107 73.2271 38.4107H74.742C76.771 38.4107 78.4158 36.7474 78.4158 34.6955C78.4158 32.6437 76.771 30.9803 74.742 30.9803H62.209C55.8904 30.9803 50.5264 26.2972 49.6043 19.9757L49.4875 19.1747C49.1416 16.8034 47.1295 15.0467 44.7593 15.0467H42.4292C42.4292 15.0467 41.9335 12.7009 40.5748 10.4766C39.216 8.25222 37.1101 6.33911 37.1101 6.33911C37.1101 6.33911 38.4046 5.78998 45.1832 5.78998Z"
            fill="#CF1427"
        />
        <path
            d="M98.4693 3.27834H100.39L103.217 11.3608L106.045 3.27834H107.966L103.989 14.2868H102.446L98.4693 3.27834ZM97.4335 3.27834H99.3463L99.6941 11.1566V14.2868H97.4335V3.27834ZM107.089 3.27834H109.009V14.2868H106.741V11.1566L107.089 3.27834ZM112.298 3.27834L114.596 8.29868L116.895 3.27834H119.367L115.746 10.2796V14.2868H113.447V10.2796L109.818 3.27834H112.298ZM97.4335 21.2783H101.539C102.381 21.2783 103.104 21.4043 103.709 21.6564C104.319 21.9084 104.788 22.2814 105.115 22.7754C105.443 23.2693 105.607 23.8767 105.607 24.5975C105.607 25.1872 105.506 25.6938 105.304 26.1172C105.108 26.5356 104.828 26.8859 104.465 27.1682C104.107 27.4454 103.686 27.6672 103.202 27.8335L102.484 28.2116H98.9154L98.9002 26.4423H101.554C101.952 26.4423 102.282 26.3718 102.545 26.2306C102.807 26.0895 103.003 25.8929 103.134 25.6409C103.27 25.3889 103.338 25.0965 103.338 24.7638C103.338 24.411 103.273 24.1061 103.142 23.849C103.011 23.5919 102.812 23.3953 102.545 23.2593C102.277 23.1232 101.942 23.0551 101.539 23.0551H99.7017V32.2868H97.4335V21.2783ZM103.588 32.2868L101.078 27.3799L103.475 27.3647L106.015 32.181V32.2868H103.588ZM114.74 30.5176V32.2868H108.88V30.5176H114.74ZM109.621 21.2783V32.2868H107.353V21.2783H109.621ZM113.976 25.7619V27.4857H108.88V25.7619H113.976ZM114.732 21.2783V23.0551H108.88V21.2783H114.732ZM120.539 23.161L117.545 32.2868H115.133L119.224 21.2783H120.758L120.539 23.161ZM123.027 32.2868L120.025 23.161L119.783 21.2783H121.333L125.446 32.2868H123.027ZM122.891 28.1889V29.9657H117.076V28.1889H122.891ZM133.544 30.5176V32.2868H128.002V30.5176H133.544ZM128.735 21.2783V32.2868H126.467V21.2783H128.735Z"
            fill="#2668B1"
        />
        <path
            d="M103.165 47.4062C103.165 47.2096 103.134 47.0332 103.074 46.8769C103.018 46.7156 102.912 46.5694 102.756 46.4384C102.6 46.3023 102.381 46.1687 102.098 46.0377C101.816 45.9066 101.451 45.7705 101.002 45.6294C100.503 45.4681 100.029 45.2866 99.5807 45.085C99.1372 44.8834 98.744 44.649 98.4012 44.3818C98.0635 44.1097 97.7964 43.7946 97.5998 43.4368C97.4083 43.0789 97.3125 42.663 97.3125 42.1892C97.3125 41.7305 97.4133 41.3147 97.6149 40.9417C97.8165 40.5637 98.0988 40.2411 98.4617 39.9739C98.8246 39.7017 99.2531 39.4926 99.7471 39.3464C100.246 39.2002 100.793 39.1271 101.388 39.1271C102.199 39.1271 102.907 39.2733 103.512 39.5656C104.117 39.858 104.586 40.2587 104.919 40.7678C105.256 41.2769 105.425 41.8591 105.425 42.5143H103.172C103.172 42.1917 103.104 41.9095 102.968 41.6675C102.837 41.4206 102.635 41.2265 102.363 41.0854C102.096 40.9442 101.758 40.8737 101.35 40.8737C100.957 40.8737 100.629 40.9341 100.367 41.0551C100.105 41.171 99.9083 41.3298 99.7773 41.5314C99.6462 41.728 99.5807 41.9498 99.5807 42.1968C99.5807 42.3833 99.6261 42.5521 99.7168 42.7034C99.8126 42.8546 99.9537 42.9957 100.14 43.1268C100.327 43.2578 100.556 43.3813 100.828 43.4972C101.1 43.6132 101.415 43.7266 101.773 43.8375C102.373 44.0189 102.9 44.2231 103.354 44.4499C103.812 44.6767 104.195 44.9313 104.503 45.2135C104.81 45.4958 105.042 45.8159 105.198 46.1737C105.355 46.5316 105.433 46.9374 105.433 47.391C105.433 47.8699 105.339 48.2983 105.153 48.6764C104.966 49.0544 104.697 49.3745 104.344 49.6366C103.991 49.8987 103.57 50.0978 103.081 50.2339C102.592 50.37 102.046 50.438 101.441 50.438C100.896 50.438 100.359 50.3675 99.8302 50.2263C99.301 50.0801 98.8196 49.8609 98.3861 49.5685C97.9577 49.2762 97.6149 48.9032 97.3579 48.4495C97.1008 47.9959 96.9723 47.4591 96.9723 46.8391H99.248C99.248 47.1819 99.301 47.4717 99.4068 47.7086C99.5127 47.9455 99.6614 48.137 99.8529 48.2832C100.049 48.4294 100.281 48.5352 100.548 48.6008C100.821 48.6663 101.118 48.699 101.441 48.699C101.834 48.699 102.156 48.6436 102.408 48.5327C102.666 48.4218 102.855 48.2681 102.975 48.0715C103.102 47.8749 103.165 47.6531 103.165 47.4062ZM111.451 41.161L108.457 50.2868H106.045L110.136 39.2783H111.67L111.451 41.161ZM113.939 50.2868L110.937 41.161L110.695 39.2783H112.245L116.358 50.2868H113.939ZM113.803 46.1889V47.9657H107.988V46.1889H113.803ZM119.647 39.2783V50.2868H117.379V39.2783H119.647ZM124.032 43.9811V45.7503H119.027V43.9811H124.032ZM124.561 39.2783V41.0551H119.027V39.2783H124.561ZM133.264 48.5176V50.2868H127.404V48.5176H133.264ZM128.145 39.2783V50.2868H125.877V39.2783H128.145ZM132.5 43.7619V45.4857H127.404V43.7619H132.5ZM133.256 39.2783V41.0551H127.404V39.2783H133.256Z"
            fill="#CF1427"
        />
    </svg>
);
export const MRSLogoWhite = () => (
    <svg width="145" height="56" viewBox="0 0 145 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M62.5425 14.6924H68.5915C73.5516 14.6924 77.5737 10.6714 77.5737 5.7113H63.4281C60.639 5.7113 59.5841 5.98431 58.8616 6.1713C58.4854 6.26868 58.1993 6.34272 57.8053 6.34272C57.8053 6.34272 59.7819 8.54475 61.0718 10.8182C62.1267 12.6777 62.5425 14.6924 62.5425 14.6924ZM23.6757 6.33914C31.9736 6.33914 38.7004 13.1418 38.7004 21.5334V42.1877C38.7004 44.6423 36.7105 46.6322 34.2559 46.6322C31.8012 46.6322 29.8113 44.6423 29.8113 42.1877V21.5334C29.8113 18.1065 27.0643 15.3285 23.6757 15.3285C20.2871 15.3285 17.54 18.1065 17.54 21.5334V37.7431C17.54 42.6524 13.5603 46.6322 8.65094 46.6322V21.5334C8.65094 13.1418 15.3777 6.33914 23.6757 6.33914ZM49.5408 38.3422V30.6947C49.5408 30.6947 51.5315 32.6515 53.9853 33.9315C55.9115 34.9363 58.4299 35.176 58.4299 35.176V47.2315C53.5206 47.2315 49.5408 43.2515 49.5408 38.3422Z"
            fill="white"
        />
        <path
            d="M45.1832 5.78998C51.9617 5.78998 57.2923 11.0813 58.2815 17.8629L58.3983 18.664C58.677 20.5751 60.2987 21.991 62.209 21.991H74.742C81.6803 21.991 87.3049 27.679 87.3049 34.6955C87.3049 41.7121 81.6803 47.4001 74.742 47.4001H64.2377C64.2377 42.4354 68.2624 38.4107 73.2271 38.4107H74.742C76.771 38.4107 78.4158 36.7474 78.4158 34.6955C78.4158 32.6437 76.771 30.9803 74.742 30.9803H62.209C55.8904 30.9803 50.5264 26.2972 49.6043 19.9757L49.4875 19.1747C49.1416 16.8034 47.1295 15.0467 44.7593 15.0467H42.4292C42.4292 15.0467 41.9335 12.7009 40.5748 10.4766C39.216 8.25222 37.1101 6.33911 37.1101 6.33911C37.1101 6.33911 38.4046 5.78998 45.1832 5.78998Z"
            fill="#F9494C"
        />
        <path
            d="M98.4693 3.27834H100.39L103.217 11.3608L106.045 3.27834H107.966L103.989 14.2868H102.446L98.4693 3.27834ZM97.4335 3.27834H99.3463L99.6941 11.1566V14.2868H97.4335V3.27834ZM107.089 3.27834H109.009V14.2868H106.741V11.1566L107.089 3.27834ZM112.298 3.27834L114.596 8.29868L116.895 3.27834H119.367L115.746 10.2796V14.2868H113.447V10.2796L109.818 3.27834H112.298ZM97.4335 21.2783H101.539C102.381 21.2783 103.104 21.4043 103.709 21.6564C104.319 21.9084 104.788 22.2814 105.115 22.7754C105.443 23.2693 105.607 23.8767 105.607 24.5975C105.607 25.1872 105.506 25.6938 105.304 26.1172C105.108 26.5356 104.828 26.8859 104.465 27.1682C104.107 27.4454 103.686 27.6672 103.202 27.8335L102.484 28.2116H98.9154L98.9002 26.4423H101.554C101.952 26.4423 102.282 26.3718 102.545 26.2306C102.807 26.0895 103.003 25.8929 103.134 25.6409C103.27 25.3889 103.338 25.0965 103.338 24.7638C103.338 24.411 103.273 24.1061 103.142 23.849C103.011 23.5919 102.812 23.3953 102.545 23.2593C102.277 23.1232 101.942 23.0551 101.539 23.0551H99.7017V32.2868H97.4335V21.2783ZM103.588 32.2868L101.078 27.3799L103.475 27.3647L106.015 32.181V32.2868H103.588ZM114.74 30.5176V32.2868H108.88V30.5176H114.74ZM109.621 21.2783V32.2868H107.353V21.2783H109.621ZM113.976 25.7619V27.4857H108.88V25.7619H113.976ZM114.732 21.2783V23.0551H108.88V21.2783H114.732ZM120.539 23.161L117.545 32.2868H115.133L119.224 21.2783H120.758L120.539 23.161ZM123.027 32.2868L120.025 23.161L119.783 21.2783H121.333L125.446 32.2868H123.027ZM122.891 28.1889V29.9657H117.076V28.1889H122.891ZM133.544 30.5176V32.2868H128.002V30.5176H133.544ZM128.735 21.2783V32.2868H126.467V21.2783H128.735Z"
            fill="white"
        />
        <path
            d="M103.165 47.4062C103.165 47.2096 103.134 47.0332 103.074 46.8769C103.018 46.7156 102.912 46.5694 102.756 46.4384C102.6 46.3023 102.381 46.1687 102.098 46.0377C101.816 45.9066 101.451 45.7705 101.002 45.6294C100.503 45.4681 100.029 45.2866 99.5807 45.085C99.1372 44.8834 98.744 44.649 98.4012 44.3818C98.0635 44.1097 97.7964 43.7946 97.5998 43.4368C97.4083 43.0789 97.3125 42.663 97.3125 42.1892C97.3125 41.7305 97.4133 41.3147 97.6149 40.9417C97.8165 40.5637 98.0988 40.2411 98.4617 39.9739C98.8246 39.7017 99.2531 39.4926 99.7471 39.3464C100.246 39.2002 100.793 39.1271 101.388 39.1271C102.199 39.1271 102.907 39.2733 103.512 39.5656C104.117 39.858 104.586 40.2587 104.919 40.7678C105.256 41.2769 105.425 41.8591 105.425 42.5143H103.172C103.172 42.1917 103.104 41.9095 102.968 41.6675C102.837 41.4206 102.635 41.2265 102.363 41.0854C102.096 40.9442 101.758 40.8737 101.35 40.8737C100.957 40.8737 100.629 40.9341 100.367 41.0551C100.105 41.171 99.9083 41.3298 99.7773 41.5314C99.6462 41.728 99.5807 41.9498 99.5807 42.1968C99.5807 42.3833 99.6261 42.5521 99.7168 42.7034C99.8126 42.8546 99.9537 42.9957 100.14 43.1268C100.327 43.2578 100.556 43.3813 100.828 43.4972C101.1 43.6132 101.415 43.7266 101.773 43.8375C102.373 44.0189 102.9 44.2231 103.354 44.4499C103.812 44.6767 104.195 44.9313 104.503 45.2135C104.81 45.4958 105.042 45.8159 105.198 46.1737C105.355 46.5316 105.433 46.9374 105.433 47.391C105.433 47.8699 105.339 48.2983 105.153 48.6764C104.966 49.0544 104.697 49.3745 104.344 49.6366C103.991 49.8987 103.57 50.0978 103.081 50.2339C102.592 50.37 102.046 50.438 101.441 50.438C100.896 50.438 100.359 50.3675 99.8302 50.2263C99.301 50.0801 98.8196 49.8609 98.3861 49.5685C97.9577 49.2762 97.6149 48.9032 97.3579 48.4495C97.1008 47.9959 96.9723 47.4591 96.9723 46.8391H99.248C99.248 47.1819 99.301 47.4717 99.4068 47.7086C99.5127 47.9455 99.6614 48.137 99.8529 48.2832C100.049 48.4294 100.281 48.5352 100.548 48.6008C100.821 48.6663 101.118 48.699 101.441 48.699C101.834 48.699 102.156 48.6436 102.408 48.5327C102.666 48.4218 102.855 48.2681 102.975 48.0715C103.102 47.8749 103.165 47.6531 103.165 47.4062ZM111.451 41.161L108.457 50.2868H106.045L110.136 39.2783H111.67L111.451 41.161ZM113.939 50.2868L110.937 41.161L110.695 39.2783H112.245L116.358 50.2868H113.939ZM113.803 46.1889V47.9657H107.988V46.1889H113.803ZM119.647 39.2783V50.2868H117.379V39.2783H119.647ZM124.032 43.9811V45.7503H119.027V43.9811H124.032ZM124.561 39.2783V41.0551H119.027V39.2783H124.561ZM133.264 48.5176V50.2868H127.404V48.5176H133.264ZM128.145 39.2783V50.2868H125.877V39.2783H128.145ZM132.5 43.7619V45.4857H127.404V43.7619H132.5ZM133.256 39.2783V41.0551H127.404V39.2783H133.256Z"
            fill="#F9494C"
        />
    </svg>
);
export const OverviewIcon = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
            <g clipPath="url(#clip0_3255_12566)">
                <path
                    d="M18.9998 8.71001L13.6668 4.56201C13.1988 4.19792 12.6227 4.00024 12.0298 4.00024C11.4368 4.00024 10.8608 4.19792 10.3928 4.56201L5.05879 8.71001C4.73823 8.9593 4.47888 9.27854 4.30054 9.64336C4.1222 10.0082 4.02959 10.4089 4.02979 10.815V18.015C4.02979 18.5454 4.2405 19.0542 4.61557 19.4292C4.99064 19.8043 5.49935 20.015 6.02979 20.015H18.0298C18.5602 20.015 19.0689 19.8043 19.444 19.4292C19.8191 19.0542 20.0298 18.5454 20.0298 18.015V10.815C20.0298 9.99201 19.6498 9.21501 18.9998 8.71001Z"
                    stroke={props.color || '#475B6C'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15C13.79 16.333 10.208 16.333 8 15"
                    stroke={props.color || '#475B6C'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_3255_12566">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
export const HouseIcon = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
            <g clipPath="url(#clip0_3255_12140)">
                <path
                    d="M5 12H3L12 3L21 12H19"
                    stroke={props.color || '#475B6C'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V12"
                    stroke={props.color || '#475B6C'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 21V15C9 14.4696 9.21071 13.9609 9.58579 13.5858C9.96086 13.2107 10.4696 13 11 13H13C13.5304 13 14.0391 13.2107 14.4142 13.5858C14.7893 13.9609 15 14.4696 15 15V21"
                    stroke={props.color || '#475B6C'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_3255_12140">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
export const DocumentIcon = (props) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M19.5 10.3711V19.5C19.5 20.0967 19.2629 20.669 18.841 21.091C18.419 21.5129 17.8467 21.75 17.25 21.75H6.75C6.15326 21.75 5.58097 21.5129 5.15901 21.091C4.73705 20.669 4.5 20.0967 4.5 19.5V4.5C4.5 3.90326 4.73705 3.33097 5.15901 2.90901C5.58097 2.48705 6.15326 2.25 6.75 2.25H11.3789C11.7766 2.25006 12.158 2.40804 12.4392 2.68922L19.0608 9.31078C19.342 9.59202 19.4999 9.97341 19.5 10.3711Z"
                stroke={props.color || '#475B6C'}
                strokeWidth="2"
                strokeLinejoin="round"
            />
            <path
                d="M12 2.625V8.25C12 8.64782 12.158 9.02936 12.4393 9.31066C12.7206 9.59196 13.1022 9.75 13.5 9.75H19.125"
                stroke={props.color || '#475B6C'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.25 13.5H15.75"
                stroke={props.color || '#475B6C'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.25 17.25H15.75"
                stroke={props.color || '#475B6C'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const ActivityIcon = (props) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_0_1)">
                <path
                    d="M9 5H7C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V7C19 6.46957 18.7893 5.96086 18.4142 5.58579C18.0391 5.21071 17.5304 5 17 5H15"
                    stroke={props.color || '#475B6C'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 3H11C9.89543 3 9 3.89543 9 5C9 6.10457 9.89543 7 11 7H13C14.1046 7 15 6.10457 15 5C15 3.89543 14.1046 3 13 3Z"
                    stroke={props.color || '#475B6C'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <path d="M9 16H12" stroke={props.color || '#475B6C'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 11H15" stroke={props.color || '#475B6C'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <defs>
                <clipPath id="clip0_0_1">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const OfferIcon = (props) => {
    return (
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 44 44"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <g id="A4-Brochure-V2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Group">
                    <path
                        d="M5.5,34.8333333 C11.6105,31.1666667 14.6666667,27.5 14.6666667,23.8333333 C14.6666667,18.3333333 12.8333333,18.3333333 11,18.3333333 C9.16666667,18.3333333 7.27466667,20.3225 7.33333333,23.8333333 C7.39566667,27.588 10.373,29.1078333 11.9166667,31.1666667 C14.6666667,34.8333333 16.5,35.75 18.3333333,33 C19.5561667,31.1666667 20.4728333,29.6395 21.0833333,28.4166667 C22.9166667,32.6938333 25.3605,34.8333333 28.4166667,34.8333333 L33,34.8333333"
                        id="Path"
                        stroke={props.color || '#475B6C'}
                        strokeWidth="2.75"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M36.6666667,31.1666667 L36.6666667,9.16666667 C36.6666667,7.1115 35.0551667,5.5 33,5.5 C30.9448333,5.5 29.3333333,7.1115 29.3333333,9.16666667 L29.3333333,31.1666667 L33,34.8333333 L36.6666667,31.1666667 Z"
                        id="Path"
                        stroke={props.color || '#475B6C'}
                        strokeWidth="2.75"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <line
                        x1="29.3333333"
                        y1="12.8333333"
                        x2="36.6666667"
                        y2="12.8333333"
                        id="Path"
                        stroke={props.color || '#475B6C'}
                        strokeWidth="2.75"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></line>
                </g>
            </g>
        </svg>
    );
};

export const OfferIconOld = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
            <g clipPath="url(#clip0_3255_12156)">
                <path
                    d="M9 15L15 9"
                    stroke={props.color || '#475B6C'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.5 10C9.77614 10 10 9.77614 10 9.5C10 9.22386 9.77614 9 9.5 9C9.22386 9 9 9.22386 9 9.5C9 9.77614 9.22386 10 9.5 10Z"
                    fill={props.color || '#475B6C'}
                    stroke={props.color || '#475B6C'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.5 15C14.7761 15 15 14.7761 15 14.5C15 14.2239 14.7761 14 14.5 14C14.2239 14 14 14.2239 14 14.5C14 14.7761 14.2239 15 14.5 15Z"
                    fill={props.color || '#475B6C'}
                    stroke={props.color || '#475B6C'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.99997 7.2C4.99997 6.61653 5.23176 6.05695 5.64434 5.64437C6.05692 5.23179 6.6165 5 7.19997 5H8.19997C8.78087 4.99967 9.33806 4.76961 9.74997 4.36L10.45 3.66C10.6544 3.4544 10.8975 3.29125 11.1652 3.17991C11.4329 3.06858 11.72 3.01126 12.01 3.01126C12.2999 3.01126 12.587 3.06858 12.8547 3.17991C13.1225 3.29125 13.3655 3.4544 13.57 3.66L14.27 4.36C14.6819 4.76961 15.2391 4.99967 15.82 5H16.82C17.4034 5 17.963 5.23179 18.3756 5.64437C18.7882 6.05695 19.02 6.61653 19.02 7.2V8.2C19.0203 8.7809 19.2504 9.33809 19.66 9.75L20.36 10.45C20.5656 10.6545 20.7287 10.8975 20.8401 11.1652C20.9514 11.433 21.0087 11.7201 21.0087 12.01C21.0087 12.3 20.9514 12.587 20.8401 12.8548C20.7287 13.1225 20.5656 13.3656 20.36 13.57L19.66 14.27C19.2504 14.6819 19.0203 15.2391 19.02 15.82V16.82C19.02 17.4035 18.7882 17.9631 18.3756 18.3756C17.963 18.7882 17.4034 19.02 16.82 19.02H15.82C15.2391 19.0203 14.6819 19.2504 14.27 19.66L13.57 20.36C13.3655 20.5656 13.1225 20.7288 12.8547 20.8401C12.587 20.9514 12.2999 21.0087 12.01 21.0087C11.72 21.0087 11.4329 20.9514 11.1652 20.8401C10.8975 20.7288 10.6544 20.5656 10.45 20.36L9.74997 19.66C9.33806 19.2504 8.78087 19.0203 8.19997 19.02H7.19997C6.6165 19.02 6.05692 18.7882 5.64434 18.3756C5.23176 17.9631 4.99997 17.4035 4.99997 16.82V15.82C4.99964 15.2391 4.76957 14.6819 4.35997 14.27L3.65997 13.57C3.45437 13.3656 3.29121 13.1225 3.17988 12.8548C3.06855 12.587 3.01123 12.3 3.01123 12.01C3.01123 11.7201 3.06855 11.433 3.17988 11.1652C3.29121 10.8975 3.45437 10.6545 3.65997 10.45L4.35997 9.75C4.76957 9.33809 4.99964 8.7809 4.99997 8.2V7.2Z"
                    stroke={props.color || '#475B6C'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_3255_12156">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
export const WebIcon = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
            <g clipPath="url(#clip0_2508_8024)">
                <path
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                    stroke={props.color || '#3E6FC3'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.6001 9H20.4001"
                    stroke={props.color || '#3E6FC3'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.6001 15H20.4001"
                    stroke={props.color || '#3E6FC3'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5002 3C9.8155 5.69961 8.92236 8.81787 8.92236 12C8.92236 15.1821 9.8155 18.3004 11.5002 21"
                    stroke={props.color || '#3E6FC3'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.5 3C14.1847 5.69961 15.0778 8.81787 15.0778 12C15.0778 15.1821 14.1847 18.3004 12.5 21"
                    stroke={props.color || '#3E6FC3'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2508_8024">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
export const EyeIcon = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
            <g clipPath="url(#clip0_2508_8036)">
                <path
                    d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
                    stroke={props.color || '#3E6FC3'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M22 12C19.333 16.667 16 19 12 19C8 19 4.667 16.667 2 12C4.667 7.333 8 5 12 5C16 5 19.333 7.333 22 12Z"
                    stroke={props.color || '#3E6FC3'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2508_8036">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
export const SettingsIcon = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M10.5111 5.17064C10.8898 3.60975 13.1102 3.60975 13.4889 5.17064C13.5457 5.40512 13.6571 5.62288 13.814 5.80619C13.9708 5.9895 14.1688 6.13317 14.3917 6.22552C14.6146 6.31787 14.8561 6.35628 15.0967 6.33763C15.3372 6.31898 15.57 6.24379 15.776 6.11819C17.1476 5.28264 18.7182 6.85241 17.8827 8.22486C17.7572 8.43077 17.6822 8.66338 17.6636 8.90377C17.645 9.14416 17.6833 9.38554 17.7756 9.60831C17.8678 9.83107 18.0113 10.0289 18.1944 10.1858C18.3775 10.3427 18.5951 10.4541 18.8293 10.5111C20.3902 10.8897 20.3902 13.1102 18.8293 13.4889C18.5948 13.5457 18.3771 13.6571 18.1938 13.8139C18.0105 13.9708 17.8668 14.1688 17.7744 14.3917C17.6821 14.6146 17.6437 14.8561 17.6623 15.0967C17.681 15.3372 17.7562 15.57 17.8818 15.776C18.7173 17.1475 17.1476 18.7182 15.7751 17.8826C15.5692 17.7572 15.3366 17.6821 15.0962 17.6635C14.8558 17.6449 14.6144 17.6833 14.3917 17.7756C14.1689 17.8678 13.971 18.0113 13.8142 18.1944C13.6573 18.3775 13.5459 18.595 13.4889 18.8293C13.1102 20.3902 10.8898 20.3902 10.5111 18.8293C10.4543 18.5948 10.3429 18.3771 10.186 18.1937C10.0292 18.0104 9.83121 17.8668 9.60831 17.7744C9.38541 17.6821 9.14385 17.6437 8.9033 17.6623C8.66275 17.681 8.43 17.7561 8.224 17.8817C6.85244 18.7173 5.28178 17.1475 6.11733 15.7751C6.24276 15.5692 6.31782 15.3366 6.33643 15.0962C6.35504 14.8558 6.31666 14.6144 6.22442 14.3916C6.13218 14.1689 5.98868 13.971 5.80558 13.8141C5.62248 13.6573 5.40495 13.5458 5.17067 13.4889C3.60978 13.1102 3.60978 10.8897 5.17067 10.5111C5.40515 10.4543 5.62291 10.3429 5.80622 10.186C5.98953 10.0291 6.1332 9.83118 6.22555 9.60828C6.3179 9.38538 6.35631 9.14382 6.33766 8.90327C6.31901 8.66272 6.24382 8.42997 6.11822 8.22397C5.28267 6.85241 6.85244 5.28175 8.22489 6.1173C9.11378 6.65775 10.2658 6.17953 10.5111 5.17064Z"
                stroke={props.color || 'white'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.0002 14.6666C13.4729 14.6666 14.6668 13.4727 14.6668 12C14.6668 10.5272 13.4729 9.3333 12.0002 9.3333C10.5274 9.3333 9.3335 10.5272 9.3335 12C9.3335 13.4727 10.5274 14.6666 12.0002 14.6666Z"
                stroke={props.color || 'white'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export const TagIcon = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
            <g clipPath="url(#clip0_2508_8062)">
                <path
                    d="M8.5 9.5C9.05228 9.5 9.5 9.05228 9.5 8.5C9.5 7.94772 9.05228 7.5 8.5 7.5C7.94772 7.5 7.5 7.94772 7.5 8.5C7.5 9.05228 7.94772 9.5 8.5 9.5Z"
                    fill={props.color || '#3E6FC3'}
                    stroke={props.color || '#3E6FC3'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 7V10.859C4 11.396 4.213 11.911 4.593 12.291L12.709 20.407C12.897 20.5951 13.1203 20.7443 13.366 20.846C13.6117 20.9478 13.875 21.0002 14.141 21.0002C14.407 21.0002 14.6703 20.9478 14.916 20.846C15.1617 20.7443 15.385 20.5951 15.573 20.407L20.407 15.573C20.5951 15.385 20.7443 15.1617 20.846 14.916C20.9478 14.6703 21.0002 14.407 21.0002 14.141C21.0002 13.875 20.9478 13.6117 20.846 13.366C20.7443 13.1203 20.5951 12.897 20.407 12.709L12.29 4.593C11.9104 4.2135 11.3957 4.00021 10.859 4H7C6.20435 4 5.44129 4.31607 4.87868 4.87868C4.31607 5.44129 4 6.20435 4 7V7Z"
                    stroke={props.color || '#3E6FC3'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2508_8062">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
export const ChecklistIcon = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
            <g clipPath="url(#clip0_2508_8074)">
                <path
                    d="M9 5H7C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V7C19 6.46957 18.7893 5.96086 18.4142 5.58579C18.0391 5.21071 17.5304 5 17 5H15"
                    stroke={props.color || '#86949F'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 3H11C9.89543 3 9 3.89543 9 5C9 6.10457 9.89543 7 11 7H13C14.1046 7 15 6.10457 15 5C15 3.89543 14.1046 3 13 3Z"
                    stroke={props.color || '#86949F'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 14H9.01"
                    stroke={props.color || '#86949F'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 17H9.01"
                    stroke={props.color || '#86949F'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16L13 17L16 14"
                    stroke={props.color || '#86949F'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2508_8074">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
export const HelpIcon = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M9.879 7.519C11.05 6.494 12.95 6.494 14.121 7.519C15.293 8.544 15.293 10.206 14.121 11.231C13.918 11.41 13.691 11.557 13.451 11.673C12.706 12.034 12.001 12.672 12.001 13.5V14.25M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12ZM12 17.25H12.008V17.258H12V17.25Z"
                stroke={props.color || '#86949F'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export const CheckIcon = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.2856 5.71439C16.0534 3.40324 12.7479 2.47635 9.6395 3.28997C6.53111 4.10359 4.10359 6.53111 3.28997 9.6395C2.47635 12.7479 3.40324 16.0534 5.71439 18.2856C7.94658 20.5968 11.2521 21.5236 14.3605 20.71C17.4689 19.8964 19.8964 17.4689 20.71 14.3605C21.5236 11.2521 20.5968 7.94658 18.2856 5.71439ZM16.685 8.69452C16.5579 8.56238 16.3849 8.48806 16.2044 8.48806C16.0239 8.48806 15.8509 8.56238 15.7239 8.69452L10.6812 13.9014L8.56268 11.7098C8.38494 11.5327 8.12911 11.4669 7.89155 11.5371C7.654 11.6073 7.4708 11.8028 7.41098 12.0501C7.35116 12.2973 7.4238 12.5587 7.60154 12.7358L10.2007 15.416C10.3278 15.5481 10.5008 15.6224 10.6812 15.6224C10.8617 15.6224 11.0347 15.5481 11.1618 15.416L16.685 9.72053C16.8239 9.5884 16.9029 9.4024 16.9029 9.20753C16.9029 9.01265 16.8239 8.82665 16.685 8.69452ZM8.05188 17.9218C10.8742 19.8051 14.6339 19.4326 17.0317 17.0321C18.3694 15.6999 19.1185 13.8879 19.1121 12C19.1095 8.60703 16.7105 5.68836 13.3822 5.02885C10.0539 4.36933 6.7232 6.15263 5.42685 9.28822C4.13051 12.4238 5.22955 16.0385 8.05188 17.9218Z"
                fill={props.color || '#86949F'}
            />
        </svg>
    );
};

export const Cross = (props) => {
    return (
        <svg
            width="32px"
            height="32px"
            viewBox="0 0 32 32"
            version="1.1"
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect x="0" y="0" width="32" height="32"></rect>
                <path
                    d="M23,15 L17,15 L17,9 C17,8.44771525 16.5522847,8 16,8 C15.4477153,8 15,8.44771525 15,9 L15,15 L9,15 C8.44771525,15 8,15.4477153 8,16 C8,16.5522847 8.44771525,17 9,17 L15,17 L15,23 C15,23.5522847 15.4477153,24 16,24 C16.5522847,24 17,23.5522847 17,23 L17,17 L23,17 C23.5522847,17 24,16.5522847 24,16 C24,15.4477153 23.5522847,15 23,15 Z"
                    fill={props?.color || '#3E6FC3'}
                    fillRule="nonzero"
                    transform="translate(16.000000, 16.000000) rotate(45.000000) translate(-16.000000, -16.000000) "
                ></path>
            </g>
        </svg>
    );
};

export const EmailIcon = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5Z"
                stroke={props.color || '#3E6FC3'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3 7L12 13L21 7"
                stroke={props.color || '#3E6FC3'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export const TimeIcon = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
            <g clipPath="url(#clip0_2508_8154)">
                <path
                    d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
                    stroke={props.color || '#86949F'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 5.83203V9.9987L12.5 12.4987"
                    stroke={props.color || '#86949F'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2508_8154">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
export const PictureIcon = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
            <g clipPath="url(#clip0_3313_17188)">
                <path
                    d="M15 8H15.01"
                    stroke={props.color ? props.color : '#3E6FC3'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 4H7C5.34315 4 4 5.34315 4 7V17C4 18.6569 5.34315 20 7 20H17C18.6569 20 20 18.6569 20 17V7C20 5.34315 18.6569 4 17 4Z"
                    stroke={props.color || '#3E6FC3'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 15L8 11C8.45606 10.5612 8.97339 10.3301 9.5 10.3301C10.0266 10.3301 10.5439 10.5612 11 11L16 16"
                    stroke={props.color || '#3E6FC3'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 14L15 13C15.4561 12.5612 15.9734 12.3301 16.5 12.3301C17.0266 12.3301 17.5439 12.5612 18 13L20 15"
                    stroke={props.color || '#3E6FC3'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_3313_17188">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const TrashIcon = (props) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M18.333 7.90869C18.112 7.90869 17.9 7.99489 17.7438 8.14832C17.5875 8.30175 17.4997 8.50985 17.4997 8.72684V17.8827C17.4758 18.2965 17.2863 18.6842 16.9726 18.9614C16.6589 19.2386 16.2463 19.3829 15.8247 19.3628H9.17467C8.75309 19.3829 8.34049 19.2386 8.02676 18.9614C7.71303 18.6842 7.52358 18.2965 7.49967 17.8827V8.72684C7.49967 8.50985 7.41188 8.30175 7.2556 8.14832C7.09932 7.99489 6.88735 7.90869 6.66634 7.90869C6.44533 7.90869 6.23337 7.99489 6.07709 8.14832C5.92081 8.30175 5.83301 8.50985 5.83301 8.72684V17.8827C5.85679 18.7305 6.22183 19.5345 6.84816 20.1186C7.47449 20.7027 8.31107 21.0193 9.17467 20.9991H15.8247C16.6883 21.0193 17.5249 20.7027 18.1512 20.1186C18.7775 19.5345 19.1426 18.7305 19.1663 17.8827V8.72684C19.1663 8.50985 19.0785 8.30175 18.9223 8.14832C18.766 7.99489 18.554 7.90869 18.333 7.90869Z"
                fill={props.color || '#3E6FC3'}
            />
            <path
                d="M19.1667 5.45445H15.8333V3.81815C15.8333 3.60116 15.7455 3.39306 15.5893 3.23963C15.433 3.0862 15.221 3 15 3H10C9.77899 3 9.56702 3.0862 9.41074 3.23963C9.25446 3.39306 9.16667 3.60116 9.16667 3.81815V5.45445H5.83333C5.61232 5.45445 5.40036 5.54064 5.24408 5.69408C5.0878 5.84751 5 6.05561 5 6.27259C5 6.48958 5.0878 6.69768 5.24408 6.85111C5.40036 7.00454 5.61232 7.09074 5.83333 7.09074H19.1667C19.3877 7.09074 19.5996 7.00454 19.7559 6.85111C19.9122 6.69768 20 6.48958 20 6.27259C20 6.05561 19.9122 5.84751 19.7559 5.69408C19.5996 5.54064 19.3877 5.45445 19.1667 5.45445ZM10.8333 5.45445V4.6363H14.1667V5.45445H10.8333Z"
                fill={props.color || '#3E6FC3'}
            />
            <path
                d="M11.6667 16.0901V10.3631C11.6667 10.1461 11.5789 9.93798 11.4226 9.78455C11.2663 9.63112 11.0543 9.54492 10.8333 9.54492C10.6123 9.54492 10.4004 9.63112 10.2441 9.78455C10.0878 9.93798 10 10.1461 10 10.3631V16.0901C10 16.3071 10.0878 16.5152 10.2441 16.6686C10.4004 16.8221 10.6123 16.9083 10.8333 16.9083C11.0543 16.9083 11.2663 16.8221 11.4226 16.6686C11.5789 16.5152 11.6667 16.3071 11.6667 16.0901Z"
                fill={props.color || '#3E6FC3'}
            />
            <path
                d="M14.9997 16.0901V10.3631C14.9997 10.1461 14.9119 9.93798 14.7556 9.78455C14.5993 9.63112 14.3874 9.54492 14.1663 9.54492C13.9453 9.54492 13.7334 9.63112 13.5771 9.78455C13.4208 9.93798 13.333 10.1461 13.333 10.3631V16.0901C13.333 16.3071 13.4208 16.5152 13.5771 16.6686C13.7334 16.8221 13.9453 16.9083 14.1663 16.9083C14.3874 16.9083 14.5993 16.8221 14.7556 16.6686C14.9119 16.5152 14.9997 16.3071 14.9997 16.0901Z"
                fill={props.color || '#3E6FC3'}
            />
        </svg>
    );
};

export const Smartphone = (props) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16 4H8C7.44772 4 7 4.44772 7 5V19C7 19.5523 7.44772 20 8 20H16C16.5523 20 17 19.5523 17 19V5C17 4.44772 16.5523 4 16 4Z"
                stroke={props?.color || '#3E6FC3'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M11 5H13" stroke={props?.color || '#3E6FC3'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M12 17V17.01"
                stroke={props?.color || '#3E6FC3'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const EstateMail = (props) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6.08704 14.7305V19.7385H11.2412"
                stroke={props?.color || '#3E6FC3'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.99988 12.2274L11.9999 4L19.9999 12.2274"
                stroke={props?.color || '#3E6FC3'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.1021 4.71484H18.1658V6.84902"
                stroke={props?.color || '#3E6FC3'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.2222 15H14.7778C14.3482 15 14 15.3638 14 15.8125V19.875C14 20.3237 14.3482 20.6875 14.7778 20.6875H20.2222C20.6518 20.6875 21 20.3237 21 19.875V15.8125C21 15.3638 20.6518 15 20.2222 15Z"
                stroke={props?.color || '#3E6FC3'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14 15.8125L17.5 18.25L21 15.8125"
                stroke={props?.color || '#3E6FC3'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const VerticalDots24 = (props) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 11C11.4477 11 11 11.4478 11 12C11 12.5523 11.4477 13 12 13C12.5522 13 13 12.5523 13 12C13 11.4478 12.5522 11 12 11Z"
                fill={props?.color || '#3E6FC3'}
                stroke={props?.color || '#3E6FC3'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 4C11.4477 4 11 4.44772 11 5C11 5.55229 11.4477 6 12 6C12.5522 6 13 5.55229 13 5C13 4.44772 12.5522 4 12 4Z"
                fill={props?.color || '#3E6FC3'}
                stroke={props?.color || '#3E6FC3'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 18C11.4477 18 11 18.4478 11 19C11 19.5523 11.4477 20 12 20C12.5522 20 13 19.5523 13 19C13 18.4478 12.5522 18 12 18Z"
                fill={props?.color || '#3E6FC3'}
                stroke={props?.color || '#3E6FC3'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const VerticalDots25 = (props) => {
    return (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.0269 11.0273C11.4746 11.0273 11.0269 11.4751 11.0269 12.0273C11.0269 12.5796 11.4746 13.0273 12.0269 13.0273C12.5791 13.0273 13.0269 12.5796 13.0269 12.0273C13.0269 11.4751 12.5791 11.0273 12.0269 11.0273Z"
                fill={props?.color || '#3E6FC3'}
                stroke={props?.color || '#3E6FC3'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.0269 4.02734C11.4746 4.02734 11.0269 4.47506 11.0269 5.02734C11.0269 5.57963 11.4746 6.02734 12.0269 6.02734C12.5791 6.02734 13.0269 5.57963 13.0269 5.02734C13.0269 4.47506 12.5791 4.02734 12.0269 4.02734Z"
                fill={props?.color || '#3E6FC3'}
                stroke={props?.color || '#3E6FC3'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.0269 18.0273C11.4746 18.0273 11.0269 18.4751 11.0269 19.0273C11.0269 19.5796 11.4746 20.0273 12.0269 20.0273C12.5791 20.0273 13.0269 19.5796 13.0269 19.0273C13.0269 18.4751 12.5791 18.0273 12.0269 18.0273Z"
                fill={props?.color || '#3E6FC3'}
                stroke={props?.color || '#3E6FC3'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const HistoryImportIcon = (props) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19"
                stroke={props?.color || '#3E6FC3'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5 13V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H11.5M2 19H9M6 16L9 19L6 22"
                stroke={props?.color || '#3E6FC3'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const FileAdd = (props) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19"
                stroke={props?.color || '#3E6FC3'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21Z"
                stroke={props?.color || '#3E6FC3'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M12 11V17" stroke={props?.color || '#3E6FC3'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 14H15" stroke={props?.color || '#3E6FC3'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export const Info24 = (props) => {
    return (
        <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1593_3596)">
                <path
                    d="M12 3C7.03727 3 3 7.03727 3 12C3 16.9627 7.03727 21 12 21C16.9627 21 21 16.9628 21 12C21 7.03724 16.9628 3 12 3ZM12 19.2C8.02998 19.2 4.8 15.97 4.8 12C4.8 8.02998 8.02998 4.8 12 4.8C15.97 4.8 19.2 8.02998 19.2 12C19.2 15.97 15.97 19.2 12 19.2ZM12.9 8.4C12.9 8.897 12.4971 9.3 12 9.3C11.5029 9.3 11.1 8.89704 11.1 8.4C11.1 7.90293 11.5029 7.5 12 7.5C12.4971 7.5 12.9 7.90293 12.9 8.4ZM12.9 11.1V15.6C12.9 16.097 12.497 16.5 12 16.5C11.503 16.5 11.1 16.097 11.1 15.6V11.1C11.1 10.603 11.503 10.2 12 10.2C12.497 10.2 12.9 10.603 12.9 11.1Z"
                    fill={props?.color || '#3E6FC3'}
                />
            </g>
            <defs>
                <clipPath id="clip0_1593_3596">
                    <rect width="18" height="18" fill="white" transform="translate(3 3)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const Check24 = (props) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.2856 5.71439C16.0534 3.40324 12.7479 2.47635 9.6395 3.28997C6.53111 4.10359 4.10359 6.53111 3.28997 9.6395C2.47635 12.7479 3.40324 16.0534 5.71439 18.2856C7.94658 20.5968 11.2521 21.5236 14.3605 20.71C17.4689 19.8964 19.8964 17.4689 20.71 14.3605C21.5236 11.2521 20.5968 7.94658 18.2856 5.71439ZM16.685 8.69452C16.5579 8.56238 16.3849 8.48806 16.2044 8.48806C16.0239 8.48806 15.8509 8.56238 15.7239 8.69452L10.6812 13.9014L8.56268 11.7098C8.38494 11.5327 8.12911 11.4669 7.89155 11.5371C7.654 11.6073 7.4708 11.8028 7.41098 12.0501C7.35116 12.2973 7.4238 12.5587 7.60154 12.7358L10.2007 15.416C10.3278 15.5481 10.5008 15.6224 10.6812 15.6224C10.8617 15.6224 11.0347 15.5481 11.1618 15.416L16.685 9.72053C16.8239 9.5884 16.9029 9.4024 16.9029 9.20753C16.9029 9.01265 16.8239 8.82665 16.685 8.69452ZM8.05188 17.9218C10.8742 19.8051 14.6339 19.4326 17.0317 17.0321C18.3694 15.6999 19.1185 13.8879 19.1121 12C19.1095 8.60703 16.7105 5.68836 13.3822 5.02885C10.0539 4.36933 6.7232 6.15263 5.42685 9.28822C4.13051 12.4238 5.22955 16.0385 8.05188 17.9218Z"
                fill={props?.color || '#3E6FC3'}
            />
        </svg>
    );
};

export const Edit24 = (props) => {
    return (
        <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.516 17.401H5.7C5.20294 17.401 4.8 16.9982 4.8 16.5013V12.6864C4.79862 12.4473 4.89253 12.2174 5.061 12.0476L11.307 5.8124L13.845 3.26614C14.014 3.09581 14.244 3 14.484 3C14.724 3 14.954 3.09581 15.123 3.26614L18.939 7.12602C19.1094 7.29496 19.2052 7.52493 19.2052 7.76484C19.2052 8.00474 19.1094 8.23471 18.939 8.40365L16.383 10.9049L10.155 17.1401C9.98515 17.3085 9.75522 17.4024 9.516 17.401ZM17.0311 7.72009L14.4841 5.17383L13.2061 6.45146L15.7531 8.99772L17.0311 7.72009ZM6.6001 13.0542L11.9371 7.71875L14.4841 10.265L9.1471 15.6005H6.6001V13.0542ZM3.9 19.2012H20.1C20.5971 19.2012 21 19.6041 21 20.1012C21 20.5982 20.5971 21.0012 20.1 21.0012H3.9C3.40294 21.0012 3 20.5982 3 20.1012C3 19.6041 3.40294 19.2012 3.9 19.2012Z"
                fill={props?.color || '#3E6FC3'}
            />
        </svg>
    );
};

export const Overview = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_3316_15859)">
                <path
                    d="M19 8.71001L13.667 4.56201C13.199 4.19792 12.623 4.00024 12.03 4.00024C11.4371 4.00024 10.861 4.19792 10.393 4.56201L5.05903 8.71001C4.73847 8.9593 4.47912 9.27854 4.30078 9.64336C4.12245 10.0082 4.02984 10.4089 4.03003 10.815V18.015C4.03003 18.5454 4.24074 19.0542 4.61582 19.4292C4.99089 19.8043 5.4996 20.015 6.03003 20.015H18.03C18.5605 20.015 19.0692 19.8043 19.4442 19.4292C19.8193 19.0542 20.03 18.5454 20.03 18.015V10.815C20.03 9.99201 19.65 9.21501 19 8.71001Z"
                    stroke="#475B6C"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15C13.79 16.333 10.208 16.333 8 15"
                    stroke="#475B6C"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_3316_15859">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const Property = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3.75 9.9375V21C3.75 21.1989 3.82902 21.3897 3.96967 21.5303C4.11032 21.671 4.30109 21.75 4.5 21.75H9V15.375C9 15.0766 9.11853 14.7905 9.3295 14.5795C9.54048 14.3685 9.82663 14.25 10.125 14.25H13.875C14.1734 14.25 14.4595 14.3685 14.6705 14.5795C14.8815 14.7905 15 15.0766 15 15.375V21.75H19.5C19.6989 21.75 19.8897 21.671 20.0303 21.5303C20.171 21.3897 20.25 21.1989 20.25 21V9.9375"
                stroke="#475B6C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.5 12L12.5105 2.43747C12.2761 2.18997 11.7281 2.18716 11.4895 2.43747L1.5 12"
                stroke="#475B6C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.75 8.39062V3H16.5V6.23438"
                stroke="#475B6C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const Bedroom = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
                d="M15.6403 6.37482H17.6248L20.6248 15.3748H3.37476L6.37476 6.37482H8.37426"
                stroke="#3E6FC3"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.6248 18.7499C20.6248 19.3716 20.1208 19.8749 19.4998 19.8749H4.49976C3.87801 19.8749 3.37476 19.3716 3.37476 18.7499V15.3749H20.6248V18.7499Z"
                stroke="#3E6FC3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M5.375 9.37494H18.6245" stroke="#3E6FC3" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.1245 7.87482H7.87451L8.62451 5.62482H15.3745L16.1245 7.87482Z"
                stroke="#3E6FC3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.375 6.37488V4.49988C6.375 3.87888 6.87825 3.37488 7.5 3.37488H16.5C17.121 3.37488 17.625 3.87888 17.625 4.49988V6.37488"
                stroke="#3E6FC3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M5.62476 19.8749V20.6249" stroke="#3E6FC3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18.3748 19.8749V20.6249" stroke="#3E6FC3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export const Bathroom = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
                d="M13.1248 13.8752H20.6248C20.6248 17.6034 17.603 20.6252 13.8748 20.6252H10.1248C6.39651 20.6252 3.37476 17.6034 3.37476 13.8752H7.87476"
                stroke="#3E6FC3"
                strokeLinejoin="round"
            />
            <path
                d="M15.9536 4.77078L16.6294 4.09428C17.5946 3.23403 19.1254 3.92478 19.1254 5.21553V13.875"
                stroke="#3E6FC3"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.9533 7.28556C16.6478 6.59106 16.6478 5.46531 15.9533 4.77081C15.2595 4.07631 14.1338 4.07631 13.4393 4.77081L13.02 5.19006L15.534 7.70481L15.9533 7.28556Z"
                stroke="#3E6FC3"
                strokeLinejoin="round"
            />
            <path d="M11.5558 5.68587L10.1938 6.31437" stroke="#3E6FC3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14.9198 9.05994L14.3303 10.4399" stroke="#3E6FC3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12.9083 7.7229L11.8418 8.7774" stroke="#3E6FC3" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.1248 13.1251C13.1248 12.7111 12.7888 12.3751 12.3748 12.3751H8.62476C8.21076 12.3751 7.87476 12.7111 7.87476 13.1251V17.6251H13.1248V13.1251Z"
                stroke="#3E6FC3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const Surface = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="20" height="20" fill="#D8D8D8" fillOpacity="0.01" />
            <path
                d="M15.7881 16.4064H16.4061V15.7883"
                stroke="#3E6FC3"
                strokeWidth="0.9"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M8.98939 16.4063H8.37134" stroke="#3E6FC3" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.13527 16.4063H6.51721" stroke="#3E6FC3" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.8436 16.4063H10.2256" stroke="#3E6FC3" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12.6978 16.4063H12.0797" stroke="#3E6FC3" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14.5518 16.4063H13.9337" stroke="#3E6FC3" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16.4061 12.08V12.698" stroke="#3E6FC3" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16.4061 10.2257V10.8438" stroke="#3E6FC3" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16.4061 8.37158V8.98964" stroke="#3E6FC3" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16.4061 6.51746V7.13551" stroke="#3E6FC3" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16.4061 13.9341V14.5521" stroke="#3E6FC3" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M5.28101 16.4062V5.28125H16.406"
                stroke="#3E6FC3"
                strokeWidth="0.9"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.3159 2.80908L16.4062 5.2813L13.3159 7.75353"
                stroke="#3E6FC3"
                strokeWidth="0.9"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2.80884 13.316L5.28106 16.4063L7.75328 13.316"
                stroke="#3E6FC3"
                strokeWidth="0.9"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const HabitableArea = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M10.125 15.3751V19.8751H18.375V15.3751" stroke="#3E6FC3" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M7.87476 15.0001L14.2498 8.62512L20.6248 15.0001"
                stroke="#3E6FC3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M17.25 9.37506H19.875V12.0001" stroke="#3E6FC3" strokeLinecap="round" strokeLinejoin="round" />
            <rect
                x="13.1248"
                y="12.3751"
                width="2.25"
                height="2.25"
                stroke="#3E6FC3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect x="3.37476" y="6.37494" width="3" height="13.5" stroke="#3E6FC3" strokeLinejoin="round" />
            <rect x="6.375" y="3.375" width="13.5" height="3" stroke="#3E6FC3" strokeLinejoin="round" />
            <rect x="3.37476" y="3.37494" width="3" height="3" stroke="#3E6FC3" strokeLinejoin="round" />
            <path d="M8.625 6.37512V4.87512" stroke="#3E6FC3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.6248 6.37512V4.87512" stroke="#3E6FC3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14.625 6.37512V4.87512" stroke="#3E6FC3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M17.625 6.37512V4.87512" stroke="#3E6FC3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.375 17.6251H4.875" stroke="#3E6FC3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.375 14.6251H4.875" stroke="#3E6FC3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.375 11.625H4.875" stroke="#3E6FC3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.375 8.625H4.875" stroke="#3E6FC3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export const GardenIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.87524 19.1249C7.87524 19.9529 7.20324 20.6249 6.37524 20.6249C5.54724 20.6249 4.87524 19.9529 4.87524 19.1249V15.3749C4.87524 14.5469 5.54724 13.8749 6.37524 13.8749C7.20324 13.8749 7.87524 14.5469 7.87524 15.3749V19.1249Z"
                stroke="#3E6FC3"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.625 19.1249C17.625 19.9529 16.953 20.6249 16.125 20.6249C15.297 20.6249 14.625 19.9529 14.625 19.1249V15.3749C14.625 14.5469 15.297 13.8749 16.125 13.8749C16.953 13.8749 17.625 14.5469 17.625 15.3749V19.1249Z"
                stroke="#3E6FC3"
                strokeLinejoin="round"
            />
            <path
                d="M9.375 3.37494V7.87494C9.375 9.53169 8.03175 10.8749 6.375 10.8749C4.71825 10.8749 3.375 9.53169 3.375 7.87494V3.37494"
                stroke="#3E6FC3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M6.375 13.8749V3.37491" stroke="#3E6FC3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16.125 13.8749V7.12489" stroke="#3E6FC3" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.1254 3.37491C19.4539 3.37491 19.8754 12.3749 19.8754 12.3749H12.3904C12.3904 12.3749 12.7969 3.37491 16.1254 3.37491Z"
                stroke="#3E6FC3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const GroundArea = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.40625 7.34375V7.90625" stroke="#3E6FC3" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.65625 16.3437H5.09375" stroke="#3E6FC3" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.34375 16.3437H6.78125" stroke="#3E6FC3" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9.03125 16.3437H8.46875" stroke="#3E6FC3" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.7187 16.3437H10.1562" stroke="#3E6FC3" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12.4062 16.3437H11.8438" stroke="#3E6FC3" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3.96875 16.3437H3.40625V15.7812" stroke="#3E6FC3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3.40625 14.6562V14.0938" stroke="#3E6FC3" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3.40625 12.9687V12.4062" stroke="#3E6FC3" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3.40625 11.2812V10.7188" stroke="#3E6FC3" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3.40625 9.59375V9.03125" stroke="#3E6FC3" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <rect
                x="5.65625"
                y="3.40625"
                width="10.6875"
                height="10.6875"
                stroke="#3E6FC3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const LocationPin = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10 11.2678C11.2081 11.2678 12.1875 10.299 12.1875 9.10388C12.1875 7.90877 11.2081 6.93994 10 6.93994C8.79188 6.93994 7.8125 7.90877 7.8125 9.10388C7.8125 10.299 8.79188 11.2678 10 11.2678Z"
                stroke="#3E6FC3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.1247 13.1843L11.0309 16.2448C10.7574 16.515 10.3867 16.6668 10.0002 16.6668C9.61368 16.6668 9.24297 16.515 8.96952 16.2448L5.87494 13.1843C5.05917 12.3772 4.50363 11.349 4.27857 10.2297C4.05351 9.11031 4.16905 7.95007 4.61057 6.89566C5.05209 5.84125 5.79976 4.94004 6.75904 4.30598C7.71832 3.67192 8.84613 3.3335 9.99984 3.3335C11.1535 3.3335 12.2814 3.67192 13.2406 4.30598C14.1999 4.94004 14.9476 5.84125 15.3891 6.89566C15.8306 7.95007 15.9462 9.11031 15.7211 10.2297C15.496 11.349 14.9405 12.3772 14.1247 13.1843V13.1843Z"
                stroke="#3E6FC3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const Fronts = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6.78125 12.9687H3.40625V3.40625H12.9687V6.78125"
                stroke="#3E6FC3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect
                x="6.78125"
                y="6.78125"
                width="9.5625"
                height="9.5625"
                stroke="#3E6FC3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const StarIcon = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M12.0056 17.2663L7.06109 20L8.00561 14.21L4 10.11L9.52774 9.26759L12 3.99997L14.4723 9.26759L20 10.11L15.9944 14.21L16.9389 20L12.0056 17.2663Z"
                stroke={props.color || '#3E6FC3'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const KeyIcon = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M8.24993 20C10.5971 20 12.4999 18.0899 12.4999 15.7336C12.4999 13.3773 10.5971 11.4672 8.24993 11.4672C5.90276 11.4672 4 13.3773 4 15.7336C4 18.0899 5.90276 20 8.24993 20Z"
                stroke={props.color || '#3E6FC3'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.2783 12.6928L19.9375 4"
                stroke={props.color || '#3E6FC3'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.875 5.0675L21 7.20072"
                stroke={props.color || '#3E6FC3'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.6875 8.26733L17.8125 10.4005"
                stroke={props.color || '#3E6FC3'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const AvatarIcon = (props) => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <circle cx="20" cy="20" r="20" fill="#D8E2F3" />
            <g clipPath="url(#clip0_4285_922)">
                <path
                    d="M20 19C22.2091 19 24 17.2091 24 15C24 12.7909 22.2091 11 20 11C17.7909 11 16 12.7909 16 15C16 17.2091 17.7909 19 20 19Z"
                    stroke={props.color ? props.color : '#3E6FC3'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 29V27C14 25.9391 14.4214 24.9217 15.1716 24.1716C15.9217 23.4214 16.9391 23 18 23H22C23.0609 23 24.0783 23.4214 24.8284 24.1716C25.5786 24.9217 26 25.9391 26 27V29"
                    stroke={props.color ? props.color : '#3E6FC3'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_4285_922">
                    <rect width="24" height="24" fill="white" transform="translate(8 8)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const PlayIcon = (props) => {
    return (
        <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M1 1V17L14 9L1 1Z"
                stroke={props.color ? props.color : '#3E6FC3'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const VirtualTourIcon = (props) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_4416_1221)">
                <mask
                    id="mask0_4416_1221"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                >
                    <path d="M0 -1.90735e-06H24V24H0V-1.90735e-06Z" fill="white" />
                </mask>
                <g mask="url(#mask0_4416_1221)">
                    <path
                        d="M9.9443 4.31921C4.55639 4.66674 0.46875 6.35546 0.46875 8.38623C0.46875 9.80855 2.47261 11.0627 5.5238 11.8059V13.3597C9.82299 12.4371 14.1824 12.4382 18.4763 13.3597V11.8059C21.5271 11.0627 23.5313 9.80855 23.5313 8.38623C23.5313 6.35438 19.4393 4.66487 14.0475 4.3186"
                        stroke={props.color ? props.color : '#3E6FC3'}
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M5.5238 11.806C2.47242 11.0632 0.46875 9.80846 0.46875 8.38632V16.3253L0.468844 16.3253C0.468844 16.326 0.46875 16.3266 0.46875 16.3271C0.46875 17.7493 2.47242 19.0034 5.5238 19.7462V11.806Z"
                        stroke={props.color ? props.color : '#3E6FC3'}
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M18.4766 11.806V19.7462C21.5279 19.0034 23.5316 17.7493 23.5316 16.3271C23.5316 16.3266 23.5315 16.3259 23.5315 16.3253L23.5316 16.3253V8.38632C23.5316 9.80846 21.5273 11.0632 18.4766 11.806Z"
                        stroke={props.color ? props.color : '#3E6FC3'}
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M19.2078 9.33354C14.9523 7.67848 9.04748 7.67674 4.79053 9.33073"
                        stroke={props.color ? props.color : '#3E6FC3'}
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M6.46926 10.0456C5.92912 9.78705 5.36915 9.54808 4.79053 9.33076C5.06976 8.78101 5.37487 8.23548 5.7059 7.69623"
                        stroke={props.color ? props.color : '#3E6FC3'}
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M18.2907 7.695C18.6224 8.23556 18.9282 8.78241 19.2079 9.33347C18.6309 9.55031 18.0725 9.78863 17.5337 10.0465"
                        stroke={props.color ? props.color : '#3E6FC3'}
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M7.40576 16.2852C7.4772 15.9212 7.79801 15.6466 8.183 15.6466C8.62043 15.6466 8.97509 16.0012 8.97509 16.4387C8.97509 16.8762 8.62043 17.2308 8.183 17.2308"
                        stroke={props.color ? props.color : '#3E6FC3'}
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M8.18321 17.2308C8.62064 17.2308 8.9753 17.5855 8.9753 18.0229C8.9753 18.4604 8.62064 18.815 8.18321 18.815C7.78322 18.815 7.45247 18.5186 7.39875 18.1334C7.39369 18.0973 7.39111 18.0604 7.39111 18.0229"
                        stroke={props.color ? props.color : '#3E6FC3'}
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M11.4904 15.6996C11.4904 15.6996 10.5422 16.405 10.3892 17.7369"
                        stroke={props.color ? props.color : '#3E6FC3'}
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M10.3794 17.8668C10.3794 17.3725 10.7802 16.9717 11.2746 16.9717C11.769 16.9717 12.1697 17.3725 12.1697 17.8668C12.1697 18.3612 11.769 18.762 11.2746 18.762C10.7802 18.762 10.3794 18.3612 10.3794 17.8668Z"
                        stroke={props.color ? props.color : '#3E6FC3'}
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M15.3143 17.9467C15.3143 18.4411 14.9134 18.8419 14.4191 18.8419C13.9247 18.8419 13.5239 18.4411 13.5239 17.9467V16.5151C13.5239 16.0207 13.9247 15.6199 14.4191 15.6199C14.9134 15.6199 15.3143 16.0207 15.3143 16.5151V17.9467Z"
                        stroke={props.color ? props.color : '#3E6FC3'}
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
                <circle
                    cx="0.5"
                    cy="0.5"
                    r="0.65"
                    transform="matrix(1 0 0 -1 16 16)"
                    stroke={props.color ? props.color : '#3E6FC3'}
                    strokeWidth="0.3"
                />
            </g>
            <defs>
                <clipPath id="clip0_4416_1221">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const Parking = (props) => {
    return (
        <svg
            width="32px"
            height="32px"
            viewBox="0 0 32 32"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect fillOpacity="0" fill="#FFFFFF" x="0" y="0" width="32" height="32"></rect>
                <g transform="translate(5.000000, 5.000000)">
                    <g stroke={props?.color || '#3E6FC3'} strokeLinecap="round" strokeLinejoin="round" strokeWidth="0.899999976">
                        <g>
                            <rect x="1.34999996" y="19.3499995" width="2.69999993" height="1.79999995"></rect>
                            <rect x="13.9499996" y="19.3499995" width="2.69999993" height="1.79999995"></rect>
                            <polygon points="17.5499995 19.3499995 17.5499995 15.7499996 15.7499996 13.9499996 2.24999994 13.9499996 0.449999988 15.7499996 0.449999988 19.3499995"></polygon>
                            <polyline points="8.05499979 9.44999975 4.04999989 9.44999975 2.24999994 13.9499996 15.7499996 13.9499996"></polyline>
                            <line x1="0.449999988" y1="17.5499995" x2="4.49999988" y2="17.5499995"></line>
                            <line x1="13.4999996" y1="17.5499995" x2="17.5499995" y2="17.5499995"></line>
                            <circle cx="15.2999996" cy="6.29999983" r="5.84999985"></circle>
                            <path d="M13.9499996,9.44999975 L13.9499996,3.14999992 L15.7499996,3.14999992 C16.7435996,3.14999992 17.5499995,3.9563999 17.5499995,4.94999987 C17.5499995,5.94359984 16.7435996,6.74999982 15.7499996,6.74999982 L13.9499996,6.74999982"></path>
                        </g>
                    </g>
                    <g>
                        <rect x="0" y="0" width="21.5999994" height="21.5999994"></rect>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const Garage = (props) => {
    return (
        <svg
            width="32px"
            height="32px"
            viewBox="0 0 32 32"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect fillOpacity="0" fill="#FFFFFF" x="0" y="0" width="32" height="32"></rect>
                <g transform="translate(5.000000, 3.000000)">
                    <g
                        transform="translate(0.000000, 3.600000)"
                        stroke={props?.color || '#3E6FC3'}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="0.899999976"
                    >
                        <g>
                            <line x1="0.449999988" y1="17.5499995" x2="21.1499994" y2="17.5499995"></line>
                            <rect x="2.24999994" y="6.74999982" width="17.0999995" height="10.7999997"></rect>
                            <polygon points="21.1499994 4.94999987 10.7999997 0.449999988 0.449999988 4.94999987 0.449999988 6.74999982 21.1499994 6.74999982"></polygon>
                            <rect x="4.04999989" y="8.54999977" width="13.4999996" height="8.99999976"></rect>
                            <line x1="5.84999985" y1="11.2499997" x2="15.7499996" y2="11.2499997"></line>
                            <line x1="5.84999985" y1="13.0499997" x2="15.7499996" y2="13.0499997"></line>
                            <line x1="5.84999985" y1="14.8499996" x2="15.7499996" y2="14.8499996"></line>
                        </g>
                    </g>
                    <g>
                        <rect x="0" y="0" width="21.5999994" height="21.5999994"></rect>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const Furnished = (props) => {
    return (
        <svg
            width="32px"
            height="32px"
            viewBox="0 0 32 32"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect fillOpacity="0" fill="#FFFFFF" x="0" y="0" width="32" height="32"></rect>
                <g transform="translate(5.000000, 2.000000)">
                    <g
                        transform="translate(0.000000, 8.100000)"
                        stroke={props?.color || '#3E6FC3'}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="0.899999976"
                    >
                        <g>
                            <line x1="2.24999994" y1="11.2499997" x2="2.24999994" y2="13.0499997"></line>
                            <line x1="19.3499995" y1="11.2499997" x2="19.3499995" y2="13.0499997"></line>
                            <path d="M0.449999988,5.84999985 L0.449999988,6.74999982 L0.449999988,9.44999975 C0.449999988,10.4435997 1.25549997,11.2499997 2.24999994,11.2499997 L19.3499995,11.2499997 C20.3435995,11.2499997 21.1499994,10.4435997 21.1499994,9.44999975 L21.1499994,6.74999982 L21.1499994,5.84999985"></path>
                            <path d="M18.4499995,5.84999985 L18.4499995,6.74999982 C18.4499995,7.24589981 18.0467995,7.6499998 17.5499995,7.6499998 L4.04999989,7.6499998 C3.55229991,7.6499998 3.14999992,7.24589981 3.14999992,6.74999982 L3.14999992,5.84999985"></path>
                            <path d="M19.3499995,4.55579988 L19.3499995,4.04999989 C19.3499995,2.06099995 17.7380995,0.449999988 15.7499999,0.449999988 L5.84999985,0.449999988 C3.8609999,0.449999988 2.24999994,2.06099995 2.24999994,4.04999989 L2.24999994,4.56929988"></path>
                            <path d="M0.449999988,5.84999985 C0.449999988,5.10299986 1.05389997,4.49999988 1.79999995,4.49999988 C2.54519993,4.49999988 3.14999992,5.10299986 3.14999992,5.84999985"></path>
                            <path d="M21.1499994,5.84999985 C21.1499994,5.10299986 20.5451995,4.49999988 19.7999995,4.49999988 C19.0538995,4.49999988 18.4499995,5.10299986 18.4499995,5.84999985"></path>
                            <line x1="10.3499997" y1="0.449999988" x2="10.3499997" y2="7.6499998"></line>
                        </g>
                    </g>
                    <g>
                        <rect x="0" y="0" width="21.5999994" height="21.5999994"></rect>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const Garden = (props) => {
    return (
        <svg
            width="32px"
            height="32px"
            viewBox="0 0 32 32"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect fillOpacity="0" fill="#FFFFFF" x="0" y="0" width="32" height="32"></rect>
                <g transform="translate(5.000000, 5.000000)">
                    <g stroke={props?.color || '#3E6FC3'} strokeLinejoin="round" strokeWidth="0.899999976">
                        <g>
                            <path d="M5.84999985,19.3499995 C5.84999985,20.3435995 5.04359987,21.1499994 4.04999989,21.1499994 C3.05639992,21.1499994 2.24999994,20.3435995 2.24999994,19.3499995 L2.24999994,14.8499996 C2.24999994,13.8563996 3.05639992,13.0499997 4.04999989,13.0499997 C5.04359987,13.0499997 5.84999985,13.8563996 5.84999985,14.8499996 L5.84999985,19.3499995 Z"></path>
                            <path d="M17.5499995,19.3499995 C17.5499995,20.3435995 16.7435996,21.1499994 15.7499996,21.1499994 C14.7563996,21.1499994 13.9499996,20.3435995 13.9499996,19.3499995 L13.9499996,14.8499996 C13.9499996,13.8563996 14.7563996,13.0499997 15.7499996,13.0499997 C16.7435996,13.0499997 17.5499995,13.8563996 17.5499995,14.8499996 L17.5499995,19.3499995 Z"></path>
                            <path
                                d="M7.6499998,0.449999988 L7.6499998,5.84999985 C7.6499998,7.83809979 6.03809984,9.44999999 4.04999989,9.44999999 C2.06189995,9.44999999 0.449999988,7.83809979 0.449999988,5.84999985 L0.449999988,0.449999988"
                                strokeLinecap="round"
                            ></path>
                            <line x1="4.04999989" y1="13.0499997" x2="4.04999989" y2="0.449999988" strokeLinecap="round"></line>
                            <line x1="15.7499996" y1="13.0499997" x2="15.7499996" y2="4.94999987" strokeLinecap="round"></line>
                            <path
                                d="M15.7499996,0.449999988 C19.7441995,0.449999988 20.2499995,11.2499997 20.2499995,11.2499997 L11.2679997,11.2499997 C11.2679997,11.2499997 11.7557997,0.449999988 15.7499996,0.449999988 Z"
                                strokeLinecap="round"
                            ></path>
                        </g>
                    </g>
                    <g>
                        <rect x="0" y="0" width="21.5999994" height="21.5999994"></rect>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const Terrace = (props) => {
    return (
        <svg
            width="32px"
            height="32px"
            viewBox="0 0 32 32"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect fillOpacity="0" fill="#FFFFFF" x="0" y="0" width="32" height="32"></rect>
                <g transform="translate(4.000000, 5.000000)">
                    <g
                        transform="translate(1.800000, 0.000000)"
                        stroke={props?.color || '#3E6FC3'}
                        strokeLinejoin="round"
                        strokeWidth="0.899999976"
                    >
                        <g>
                            <path
                                d="M4.94999987,9.89999974 C4.94999987,11.1428997 5.95709984,12.1499997 7.19999981,12.1499997 C8.44289978,12.1499997 9.44999975,11.1428997 9.44999975,9.89999974 C9.44999975,11.1428997 10.4570997,12.1499997 11.6999997,12.1499997 C12.9428997,12.1499997 13.9499996,11.1428997 13.9499996,9.89999974 C13.9499996,11.1428997 14.9570996,12.1499997 16.1999996,12.1499997 C16.4357996,12.1499997 16.6625996,12.1139997 16.8749996,12.0473997 C17.4752995,11.8574997 17.9333995,11.3687997 18.0827995,10.7576997 C18.2321995,10.1465997 18.0521995,9.50129975 17.6075995,9.05669976 L9.44999975,0.449999988 L1.17449997,9.09899976 C0.791999979,9.52199975 0.631799983,10.1006997 0.74339998,10.6595997 C0.854999977,11.2184997 1.22399997,11.6909997 1.73879995,11.9348997 C2.03129995,12.0734997 2.35619994,12.1499997 2.69999993,12.1499997 C3.9428999,12.1499997 4.94999987,11.1428997 4.94999987,9.89999974"
                                strokeLinecap="round"
                            ></path>
                            <line x1="9.44999975" y1="21.5999994" x2="9.44999975" y2="0.449999988"></line>
                            <polyline
                                strokeLinecap="round"
                                points="17.5499995 14.4143996 16.6499996 18.4499995 12.1499997 18.4499995 12.1499997 21.1355994"
                            ></polyline>
                            <polyline
                                strokeLinecap="round"
                                points="1.34999996 14.4143996 2.24999994 18.4499995 6.74999982 18.4499995 6.74999982 21.1355994"
                            ></polyline>
                            <line x1="4.94999987" y1="9.89999974" x2="9.44999975" y2="0.449999988" strokeLinecap="round"></line>
                            <line x1="13.9499996" y1="9.89999974" x2="9.44999975" y2="0.449999988" strokeLinecap="round"></line>
                            <line x1="2.24999994" y1="18.4499995" x2="2.24999994" y2="21.1499994" strokeLinecap="round"></line>
                            <line x1="16.6499996" y1="18.4499995" x2="16.6499996" y2="21.1499994" strokeLinecap="round"></line>
                        </g>
                    </g>
                    <g>
                        <rect x="0" y="0" width="21.5999994" height="21.5999994"></rect>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const ClientLogo = () => (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="40" cy="40" r="40" fill="#ECECEC" />
        <path
            d="M53.5864 44.79C53.5864 45.79 52.7683 46.6081 51.7683 46.6081H28.2318C27.2319 46.6081 26.4138 45.79 26.4138 44.79C26.4138 43.7901 27.2319 42.972 28.2318 42.972H51.7683C52.7683 42.9719 53.5864 43.79 53.5864 44.79ZM53.3728 27.7899L41.0636 17.7275C40.754 17.4745 40.3728 17.392 40.0002 17.392C39.6274 17.392 39.2462 17.4745 38.9367 17.7275L33.0147 22.5685V20.4865C33.0147 19.57 32.2648 18.8201 31.3482 18.8201C30.4317 18.8201 29.6817 19.57 29.6817 20.4865V25.2931L26.6274 27.7899C25.9837 28.3161 25.8876 29.2732 26.4138 29.9169C26.94 30.5605 27.8971 30.6567 28.5407 30.1305C32.3613 27.0074 36.1776 23.8877 40.0001 20.7629L51.4595 30.1305C52.1032 30.6567 53.0603 30.5605 53.5864 29.9169C54.1126 29.2732 54.0165 28.316 53.3728 27.7899ZM49.8733 42.097V29.9639L40.0001 21.8929L30.1268 29.9639V42.097H36.3278V33.4564H43.6723V42.097H49.8733Z"
            fill="black"
            fillOpacity="0.24"
        />
        <path
            d="M23.6 52.504V61H28.832V58.984H26.264V52.504H23.6ZM38.1663 56.716C38.1663 54.16 36.2343 52.36 33.8103 52.36C31.3983 52.36 29.4303 54.16 29.4303 56.716C29.4303 59.272 31.3983 61.084 33.8103 61.084C36.2103 61.084 38.1663 59.272 38.1663 56.716ZM32.1423 56.716C32.1423 55.564 32.7183 54.82 33.8103 54.82C34.8783 54.82 35.4663 55.564 35.4663 56.716C35.4663 57.844 34.8783 58.6 33.8103 58.6C32.7183 58.6 32.1423 57.844 32.1423 56.716ZM43.1833 52.42C40.5193 52.42 38.8873 54.208 38.8873 56.74C38.8873 59.272 40.5313 61.06 43.2073 61.06C45.4033 61.06 46.6033 59.776 47.1913 58.756V56.092H42.8593V57.976H44.9833C44.5873 58.504 44.0953 58.72 43.4953 58.72C42.1873 58.72 41.5873 58.06 41.5873 56.74C41.5873 55.612 42.1633 54.88 43.1953 54.88C43.7473 54.88 44.1313 55.084 44.3353 55.408H47.1433C46.8913 53.596 45.4393 52.42 43.1833 52.42ZM56.6468 56.716C56.6468 54.16 54.7148 52.36 52.2908 52.36C49.8788 52.36 47.9108 54.16 47.9108 56.716C47.9108 59.272 49.8788 61.084 52.2908 61.084C54.6908 61.084 56.6468 59.272 56.6468 56.716ZM50.6228 56.716C50.6228 55.564 51.1988 54.82 52.2908 54.82C53.3588 54.82 53.9468 55.564 53.9468 56.716C53.9468 57.844 53.3588 58.6 52.2908 58.6C51.1988 58.6 50.6228 57.844 50.6228 56.716Z"
            fill="black"
            fillOpacity="0.24"
        />
    </svg>
);

export const ConnektoLogo = () => (
    <svg width="599" height="102" viewBox="0 0 599 102" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M195.3 24.7C190.4 24.7 185.8 26 181.5 28.5C177.2 31 173.8 34.2 171.4 37.9V33C171.4 32.8 171.3 30.3 171.3 30.3C171.3 30.2 171.3 30 171.3 29.9C171.1 29 171 28.3 170.1 27.4C170 27.3 170 27.3 169.9 27.2L169.6 26.9C169.5 26.8 169.4 26.8 169.3 26.7C168.7 26.4 168.1 26.3 168.1 26.3C167.4 26.2 166.8 26.3 166.3 26.4C166 26.5 165.8 26.6 165.6 26.6C165.2 26.8 161.6 28.6 159.4 29.7C159.2 29.8 159 30 158.8 30.2C158.5 30.5 158.3 31 158.3 31.5C158.3 31.5 158.3 32.7 158.3 32.9V92.3C158.3 94.8 158.3 98.7 158.3 100.3H167.8C169.8 100.3 171.5 98.4 171.5 96.3C171.5 96.3 171.5 90.3 171.5 90.1V54.8C171.5 51.6 172.4 48.6 174.1 45.8C175.8 43.1 178.2 40.9 181.2 39.3C184.2 37.7 187.6 36.9 191.3 36.9C196.9 36.9 201 38.5 203.5 41.8C206 45 207.2 49.4 207.2 54.8V90.3C207.2 90.4 207.2 98 207.2 100.5H216.7C218.7 100.5 220.4 98.6 220.4 96.5C220.4 96.5 220.4 94.2 220.4 92.4V54.7C220.3 34.7 211.9 24.7 195.3 24.7Z"
            fill="#2668B1"
        />
        <path
            d="M277.2 25.4C272.3 25.4 267.7 26.7 263.4 29.2C259.1 31.7 255.7 34.9 253.3 38.6V33.7C253.3 33.5 253.2 31 253.2 31C253.2 30.9 253.2 30.7 253.2 30.6C253 29.7 252.9 29 252 28.1C251.9 28 251.9 28 251.8 27.9L251.5 27.6C251.4 27.5 251.3 27.5 251.2 27.4C250.6 27.1 250 27 250 27C249.3 26.9 248.7 27 248.2 27.1C247.9 27.2 247.7 27.3 247.5 27.3C247.1 27.5 243.5 29.3 241.3 30.4C241.1 30.5 240.9 30.7 240.7 30.9C240.4 31.2 240.2 31.7 240.2 32.2C240.2 32.2 240.2 33.4 240.2 33.6V93C240.2 95.5 240.2 98.9 240.2 100.4H249.7C251.7 100.4 253.4 98.5 253.4 96.4C253.4 96.4 253.4 90.4 253.4 90.2V55.5C253.4 52.3 254.3 49.3 256 46.5C257.7 43.8 260.1 41.6 263.1 40C266.1 38.4 269.5 37.6 273.2 37.6C278.8 37.6 282.9 39.2 285.4 42.5C287.9 45.7 289.1 50.1 289.1 55.5V90.3C289.1 90.4 289.1 98 289.1 100.5H298.6C300.6 100.5 302.3 98.6 302.3 96.5C302.3 96.5 302.3 94.8 302.3 93.1V55.4C302.2 35.4 293.8 25.4 277.2 25.4Z"
            fill="#2668B1"
        />
        <path
            d="M505.1 27.2H499.6C498.5 27.2 497.6 26.3 497.6 25.2V11.2C497.5 9.4 496.4 7.8 494.8 7.3L494.4 7.2C493.8 7.1 492.7 7 491.6 7.6C490.8 8 487.6 9.7 485.5 10.7C484.8 11 484.4 11.7 484.4 12.5V15.1C484.4 15.2 484.4 15.3 484.4 15.5V25.4C484.3 26.4 483.5 27.2 482.4 27.2C482 27.2 481.7 27.2 481.4 27.2H479.6C477.9 27.2 474.1 27.2 474.1 27.2C472 27.2 470.1 28.8 470.1 30.9V39.3C472.5 39.3 480.1 39.3 480.2 39.3H482.2C483.3 39.3 484.1 40.1 484.2 41.1V81.2C484.2 86.6 485.2 90.6 487.2 93.2C489.2 95.8 491.5 97.5 494 98.1C496.5 98.7 499.3 99.1 502.4 99.1C502.7 99.1 503 99.1 503.2 99C503.4 99 509.4 99 509.4 99C511.5 99 513.4 97.4 513.4 95.3V87.4C511.8 87.4 507.8 87.4 505.4 87.4C504.7 87.4 504.2 87.4 503.7 87.4C499.5 87.4 497.5 85.1 497.5 80.5V55.5C497.5 55.4 497.5 55.3 497.5 55.2V41.2C497.5 40.1 498.4 39.2 499.5 39.2C500.1 39.2 500.7 39.2 501.1 39.2H505.3C506.6 39.2 511.1 39.2 511.1 39.2C513.2 39.2 515.1 37.6 515.1 35.5V27C512.8 27.1 505.2 27.2 505.1 27.2Z"
            fill="#2668B1"
        />
        <path
            d="M50.6 83.4C50.3 83.6 50.1 83.8 49.8 84L49.7 84.1C49.3 84.4 49 84.7 48.5 84.9C47.6 85.4 46.7 85.9 45.7 86.3H45.6C45.4 86.4 45.3 86.5 45.1 86.5C44.9 86.6 44.7 86.6 44.6 86.7C44.3 86.8 44 86.9 43.7 87C43.4 87.1 43.1 87.2 42.9 87.3C42.4 87.5 41.8 87.6 41.2 87.7C40.9 87.8 40.7 87.8 40.4 87.8C40.1 87.8 39.9 87.9 39.6 87.9C39.2 87.9 38.9 88 38.5 88C37.9 88 37.3 88.1 36.8 88.1C36.7 88.1 36.7 88.1 36.6 88.1C32.3 88.1 28.3 87 24.7 84.8C22.5 83.4 20.5 81.7 18.9 79.6C17.9 78.4 17 77 16.3 75.6C14.2 71.7 13.2 67.2 13.2 62.2C13.2 57.3 14.2 52.9 16.3 49C18.4 45.1 21.2 42.1 24.8 39.9C28.4 37.7 32.3 36.6 36.7 36.6C39.7 36.6 42.6 37.1 45.2 38.2C46.4 38.7 47.5 39.2 48.6 39.9C49.3 40.3 50 40.8 50.7 41.4L58.3 34.4C59.2 33.5 59.1 32 58 31.2C57.1 30.5 56.2 30 55.3 29.4L55.2 29.3C55 29.2 54.8 29.1 54.6 29C49.2 26 43.2 24.5 36.7 24.5C29.9 24.5 23.8 26.1 18.2 29.4C12.6 32.6 8.2 37.1 4.9 42.9C1.7 48.6 0 55.1 0 62.3C0 66.2 0.5 69.8 1.4 73.3V73.4C1.6 74.1 1.8 74.7 2 75.4C2.1 75.8 2.3 76.3 2.5 76.7C2.6 77 2.7 77.2 2.8 77.5C3.4 79 4.1 80.5 4.9 81.9C5.3 82.6 5.7 83.2 6.1 83.9C6 83.9 6 84 6 84C6.2 84.3 6.4 84.6 6.6 84.8C9.6 89.2 13.4 92.7 18.1 95.4C23.7 98.6 29.9 100.3 36.6 100.3C43.3 100.3 49.5 98.7 55.1 95.4C55.7 95 56.3 94.7 56.9 94.3C57.3 94.1 57.6 93.8 58 93.5C59 92.7 59.2 91.2 58.3 90.3L50.6 83.4Z"
            fill="#2668B1"
        />
        <path
            d="M380.7 41.9C377.6 36.5 373.4 32.3 368.2 29.3C363 26.2 357.5 24.7 351.5 24.7C345.5 24.7 339.9 26.3 334.6 29.4C329.4 32.5 325.2 37.1 322 42.9C318.8 48.8 317.2 55.6 317.2 63.4C317.2 70.5 318.7 76.9 321.8 82.6C324.9 88.2 329.3 92.6 335 95.8C339.7 98.4 345 99.9 350.9 100.4C351.3 100.4 357.1 100.4 357.1 100.4C359.2 100.4 361 98.7 361 96.7V88.2C358.6 88.2 351 88.2 350.9 88.2C345.8 87.6 341.3 85.7 337.6 82.3C333.1 78.2 330.5 72.8 329.9 66.1H378.8C380.6 66.1 382.1 65.5 383.4 64.4C384.7 63.2 385.4 61.8 385.5 60.2C385.5 53.3 383.8 47.3 380.7 41.9ZM330.6 54.8C331.8 48.7 334.3 44.2 338.1 41.3C341.9 38.4 346.4 36.9 351.6 36.9C356.6 36.9 361.1 38.5 365 41.6C368.9 44.7 371.1 48.8 371.6 53.7V54.8H330.6Z"
            fill="#2668B1"
        />
        <path
            d="M415.1 48.5V4.1C415.1 4 415.1 3.8 415.1 3.7C415.1 3.6 415 3.5 415 3.3C414.8 2.6 414.7 1.9 413.9 1.2C413.8 1.1 413.8 1.1 413.7 1L413.4 0.700002C413.3 0.600002 413.2 0.600003 413.1 0.500003C412.4 0.200003 411.9 0.100003 411.9 0.100003C410.8 -0.0999974 409.8 0.300003 409.4 0.500003C409 0.700003 405.4 2.5 403.1 3.6C402.4 3.9 402 4.6 402 5.4V53.7C402 54.8 402 54 402 56.5V93.9C402 94 402 94.1 402 94.2V97.8C402 98.9 402 98.1 402 100.6H411.4C413.4 100.6 415.1 98.7 415.1 96.6V94.5C415.1 94.3 415.2 94.1 415.2 93.9"
            fill="#2668B1"
        />
        <path
            d="M437.4 70.7L457.1 49.3C457.2 49.2 462.3 43.7 464 41.9L457.1 35.3C455.6 33.9 453.1 34.1 451.7 35.7C451.7 35.7 447.6 40.1 447.4 40.2L424.3 64.7C424.2 64.8 424 65 423.9 65.2C422.7 66.5 421.2 68 421.2 68C419.7 69.5 419.6 72 421.1 73.4L426.2 78.4L427.2 79.3L443.5 95.1C443.7 95.2 447.9 99.4 447.9 99.4C449.4 100.9 451.9 101 453.3 99.5L459.9 92.6C458.1 90.9 452.8 85.6 452.7 85.5L437.4 70.7Z"
            fill="#CF1327"
        />
        <path
            d="M597.6 52.7C597.6 52.6 597.5 52.5 597.5 52.3C597.4 52 597.4 51.6 597.3 51.3C597.3 51.2 597.2 51.1 597.2 51C597.2 50.9 597.1 50.8 597.1 50.7C596.6 49.1 596.1 47.5 595.4 46C595 45.1 593.8 44.8 593 45.6L585.8 52.9L584.3 54.3C584.5 55.1 584.7 55.8 584.9 56.6C585.3 58.5 585.4 60.4 585.4 62.4C585.4 65 585.1 67.4 584.6 69.7H584.5C584 71.8 583.2 73.8 582.2 75.7C580.1 79.6 577.3 82.7 573.7 84.9C570.1 87.1 566.2 88.2 561.8 88.2C557.5 88.2 553.5 87.1 549.9 84.9C546.3 82.7 543.5 79.7 541.4 75.7C540.9 74.8 540.5 73.8 540.1 72.8C539.7 71.8 539.4 70.8 539.2 69.8C538.6 67.5 538.3 65 538.3 62.3C538.3 60.3 538.5 58.5 538.8 56.7C539.3 54 540.2 51.5 541.4 49.2C543.5 45.3 546.3 42.3 549.9 40.1C553.5 37.9 557.4 36.8 561.8 36.8C564.1 36.8 566.4 37.1 568.5 37.8L576.7 29.6C577.4 28.9 577.2 27.7 576.2 27.3C571.7 25.4 566.9 24.5 561.7 24.5C554.9 24.5 548.8 26.1 543.2 29.4C537.6 32.6 533.2 37.1 529.9 42.9C526.7 48.6 525 55.1 525 62.3C525 67.5 525.9 72.4 527.6 76.9C527.7 77.1 527.7 77.2 527.8 77.4C527.8 77.5 527.9 77.6 528 77.8C528.6 79.3 529.2 80.7 530 82C533.2 87.8 537.7 92.4 543.3 95.6C548.9 98.8 555.1 100.5 561.8 100.5C568.6 100.5 574.7 98.9 580.3 95.6C585.9 92.4 590.3 87.8 593.6 82C596.8 76.2 598.5 69.6 598.5 62.4C598.7 59 598.3 55.8 597.6 52.7Z"
            fill="#2668B1"
        />
        <path
            d="M143.1 72.1C143.1 71.9 143.2 71.7 143.2 71.5C143.7 69 143.9 66.4 143.9 63.6C143.9 56.4 142.3 49.9 139 44.2C135.8 38.5 131.3 34 125.7 30.7C120.1 27.5 113.9 25.8 107.2 25.8C102 25.8 97.2 26.7 92.7 28.6C92.6 28.7 92.5 28.7 92.4 28.8C91.1 29.4 89.8 30 88.6 30.7C83 33.9 78.6 38.4 75.3 44.2C74.7 45.2 74.3 46.2 73.8 47.2V47.3C71.6 52.2 70.5 57.7 70.5 63.6C70.5 68.8 71.4 73.7 73.1 78.2C73.2 78.4 73.2 78.5 73.3 78.7C73.3 78.8 73.4 78.9 73.5 79.1C74.1 80.6 74.7 82 75.5 83.3C78.7 89.1 83.2 93.7 88.8 96.9C94.4 100.1 100.6 101.8 107.3 101.8C114.1 101.8 120.2 100.2 125.8 96.9C131.4 93.7 135.8 89.1 139.1 83.3C140.8 80.2 142.1 76.8 142.9 73.3C142.9 73 143 72.5 143.1 72.1ZM95.4 41.5C99 39.3 102.9 38.2 107.3 38.2C109.6 38.2 111.9 38.5 114 39.2L114.1 39.1C115.9 39.6 117.6 40.4 119.2 41.4C122.8 43.6 125.6 46.6 127.7 50.5C128.6 52.1 129.2 53.8 129.7 55.6C129.9 56.4 130.1 57.1 130.3 57.9C130.7 59.8 130.8 61.7 130.8 63.7C130.8 65.9 130.6 68.1 130.2 70.1C130.1 70.4 130.1 70.7 130 71C129.5 73.1 128.7 75.1 127.7 77C126.7 78.9 125.5 80.7 124.1 82.2C122.7 83.7 121.1 85 119.3 86.1C115.7 88.3 111.8 89.4 107.4 89.4C103 89.4 99.1 88.3 95.5 86.1C91.9 84 89 81 86.9 77C85.9 75.1 85.2 73.1 84.6 71H84.5C83.9 68.7 83.7 66.3 83.7 63.7C83.7 61.7 83.9 59.9 84.2 58.1C84.2 58 84.2 58 84.2 57.9C84.2 57.8 84.2 57.8 84.2 57.7C84.3 57.3 84.4 56.9 84.5 56.5C84.6 56.2 84.6 56 84.7 55.7C85.2 53.9 85.9 52.2 86.7 50.6C89 46.7 91.8 43.7 95.4 41.5Z"
            fill="#2668B1"
        />
        <path
            d="M582.4 47.8C585.99 47.8 588.9 44.8899 588.9 41.3C588.9 37.7102 585.99 34.8 582.4 34.8C578.81 34.8 575.9 37.7102 575.9 41.3C575.9 44.8899 578.81 47.8 582.4 47.8Z"
            fill="#CF1327"
        />
    </svg>
);

export const ConnektoLogoWhite = () => (
    <svg width="599" height="102" viewBox="0 0 599 102" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M195.3 24.7C190.4 24.7 185.8 26 181.5 28.5C177.2 31 173.8 34.2 171.4 37.9V33C171.4 32.8 171.3 30.3 171.3 30.3C171.3 30.2 171.3 30 171.3 29.9C171.1 29 171 28.3 170.1 27.4C170 27.3 170 27.3 169.9 27.2L169.6 26.9C169.5 26.8 169.4 26.8 169.3 26.7C168.7 26.4 168.1 26.3 168.1 26.3C167.4 26.2 166.8 26.3 166.3 26.4C166 26.5 165.8 26.6 165.6 26.6C165.2 26.8 161.6 28.6 159.4 29.7C159.2 29.8 159 30 158.8 30.2C158.5 30.5 158.3 31 158.3 31.5C158.3 31.5 158.3 32.7 158.3 32.9V92.3C158.3 94.8 158.3 98.7 158.3 100.3H167.8C169.8 100.3 171.5 98.4 171.5 96.3C171.5 96.3 171.5 90.3 171.5 90.1V54.8C171.5 51.6 172.4 48.6 174.1 45.8C175.8 43.1 178.2 40.9 181.2 39.3C184.2 37.7 187.6 36.9 191.3 36.9C196.9 36.9 201 38.5 203.5 41.8C206 45 207.2 49.4 207.2 54.8V90.3C207.2 90.4 207.2 98 207.2 100.5H216.7C218.7 100.5 220.4 98.6 220.4 96.5C220.4 96.5 220.4 94.2 220.4 92.4V54.7C220.3 34.7 211.9 24.7 195.3 24.7Z"
            fill="white"
        />
        <path
            d="M277.2 25.4C272.3 25.4 267.7 26.7 263.4 29.2C259.1 31.7 255.7 34.9 253.3 38.6V33.7C253.3 33.5 253.2 31 253.2 31C253.2 30.9 253.2 30.7 253.2 30.6C253 29.7 252.9 29 252 28.1C251.9 28 251.9 28 251.8 27.9L251.5 27.6C251.4 27.5 251.3 27.5 251.2 27.4C250.6 27.1 250 27 250 27C249.3 26.9 248.7 27 248.2 27.1C247.9 27.2 247.7 27.3 247.5 27.3C247.1 27.5 243.5 29.3 241.3 30.4C241.1 30.5 240.9 30.7 240.7 30.9C240.4 31.2 240.2 31.7 240.2 32.2C240.2 32.2 240.2 33.4 240.2 33.6V93C240.2 95.5 240.2 98.9 240.2 100.4H249.7C251.7 100.4 253.4 98.5 253.4 96.4C253.4 96.4 253.4 90.4 253.4 90.2V55.5C253.4 52.3 254.3 49.3 256 46.5C257.7 43.8 260.1 41.6 263.1 40C266.1 38.4 269.5 37.6 273.2 37.6C278.8 37.6 282.9 39.2 285.4 42.5C287.9 45.7 289.1 50.1 289.1 55.5V90.3C289.1 90.4 289.1 98 289.1 100.5H298.6C300.6 100.5 302.3 98.6 302.3 96.5C302.3 96.5 302.3 94.8 302.3 93.1V55.4C302.2 35.4 293.8 25.4 277.2 25.4Z"
            fill="white"
        />
        <path
            d="M505.1 27.2H499.6C498.5 27.2 497.6 26.3 497.6 25.2V11.2C497.5 9.40001 496.4 7.80001 494.8 7.30001L494.4 7.20001C493.8 7.10001 492.7 7.00001 491.6 7.60001C490.8 8.00001 487.6 9.70001 485.5 10.7C484.8 11 484.4 11.7 484.4 12.5V15.1C484.4 15.2 484.4 15.3 484.4 15.5V25.4C484.3 26.4 483.5 27.2 482.4 27.2C482 27.2 481.7 27.2 481.4 27.2H479.6C477.9 27.2 474.1 27.2 474.1 27.2C472 27.2 470.1 28.8 470.1 30.9V39.3C472.5 39.3 480.1 39.3 480.2 39.3H482.2C483.3 39.3 484.1 40.1 484.2 41.1V81.2C484.2 86.6 485.2 90.6 487.2 93.2C489.2 95.8 491.5 97.5 494 98.1C496.5 98.7 499.3 99.1 502.4 99.1C502.7 99.1 503 99.1 503.2 99C503.4 99 509.4 99 509.4 99C511.5 99 513.4 97.4 513.4 95.3V87.4C511.8 87.4 507.8 87.4 505.4 87.4C504.7 87.4 504.2 87.4 503.7 87.4C499.5 87.4 497.5 85.1 497.5 80.5V55.5C497.5 55.4 497.5 55.3 497.5 55.2V41.2C497.5 40.1 498.4 39.2 499.5 39.2C500.1 39.2 500.7 39.2 501.1 39.2H505.3C506.6 39.2 511.1 39.2 511.1 39.2C513.2 39.2 515.1 37.6 515.1 35.5V27C512.8 27.1 505.2 27.2 505.1 27.2Z"
            fill="white"
        />
        <path
            d="M50.6 83.4C50.3 83.6 50.1 83.8 49.8 84L49.7 84.1C49.3 84.4 49 84.7 48.5 84.9C47.6 85.4 46.7 85.9 45.7 86.3H45.6C45.4 86.4 45.3 86.5 45.1 86.5C44.9 86.6 44.7 86.6 44.6 86.7C44.3 86.8 44 86.9 43.7 87C43.4 87.1 43.1 87.2 42.9 87.3C42.4 87.5 41.8 87.6 41.2 87.7C40.9 87.8 40.7 87.8 40.4 87.8C40.1 87.8 39.9 87.9 39.6 87.9C39.2 87.9 38.9 88 38.5 88C37.9 88 37.3 88.1 36.8 88.1C36.7 88.1 36.7 88.1 36.6 88.1C32.3 88.1 28.3 87 24.7 84.8C22.5 83.4 20.5 81.7 18.9 79.6C17.9 78.4 17 77 16.3 75.6C14.2 71.7 13.2 67.2 13.2 62.2C13.2 57.3 14.2 52.9 16.3 49C18.4 45.1 21.2 42.1 24.8 39.9C28.4 37.7 32.3 36.6 36.7 36.6C39.7 36.6 42.6 37.1 45.2 38.2C46.4 38.7 47.5 39.2 48.6 39.9C49.3 40.3 50 40.8 50.7 41.4L58.3 34.4C59.2 33.5 59.1 32 58 31.2C57.1 30.5 56.2 30 55.3 29.4L55.2 29.3C55 29.2 54.8 29.1 54.6 29C49.2 26 43.2 24.5 36.7 24.5C29.9 24.5 23.8 26.1 18.2 29.4C12.6 32.6 8.2 37.1 4.9 42.9C1.7 48.6 0 55.1 0 62.3C0 66.2 0.5 69.8 1.4 73.3V73.4C1.6 74.1 1.8 74.7 2 75.4C2.1 75.8 2.3 76.3 2.5 76.7C2.6 77 2.7 77.2 2.8 77.5C3.4 79 4.1 80.5 4.9 81.9C5.3 82.6 5.7 83.2 6.1 83.9C6 83.9 6 84 6 84C6.2 84.3 6.4 84.6 6.6 84.8C9.6 89.2 13.4 92.7 18.1 95.4C23.7 98.6 29.9 100.3 36.6 100.3C43.3 100.3 49.5 98.7 55.1 95.4C55.7 95 56.3 94.7 56.9 94.3C57.3 94.1 57.6 93.8 58 93.5C59 92.7 59.2 91.2 58.3 90.3L50.6 83.4Z"
            fill="white"
        />
        <path
            d="M380.7 41.9C377.6 36.5 373.4 32.3 368.2 29.3C363 26.2 357.5 24.7 351.5 24.7C345.5 24.7 339.9 26.3 334.6 29.4C329.4 32.5 325.2 37.1 322 42.9C318.8 48.8 317.2 55.6 317.2 63.4C317.2 70.5 318.7 76.9 321.8 82.6C324.9 88.2 329.3 92.6 335 95.8C339.7 98.4 345 99.9 350.9 100.4C351.3 100.4 357.1 100.4 357.1 100.4C359.2 100.4 361 98.7 361 96.7V88.2C358.6 88.2 351 88.2 350.9 88.2C345.8 87.6 341.3 85.7 337.6 82.3C333.1 78.2 330.5 72.8 329.9 66.1H378.8C380.6 66.1 382.1 65.5 383.4 64.4C384.7 63.2 385.4 61.8 385.5 60.2C385.5 53.3 383.8 47.3 380.7 41.9ZM330.6 54.8C331.8 48.7 334.3 44.2 338.1 41.3C341.9 38.4 346.4 36.9 351.6 36.9C356.6 36.9 361.1 38.5 365 41.6C368.9 44.7 371.1 48.8 371.6 53.7V54.8H330.6Z"
            fill="white"
        />
        <path
            d="M415.1 48.5V4.10001C415.1 4.00001 415.1 3.80001 415.1 3.70001C415.1 3.60001 415 3.50001 415 3.30001C414.8 2.60001 414.7 1.90001 413.9 1.20001C413.8 1.10001 413.8 1.10001 413.7 1.00001L413.4 0.70001C413.3 0.60001 413.2 0.60001 413.1 0.50001C412.4 0.20001 411.9 0.10001 411.9 0.10001C410.8 -0.0999898 409.8 0.30001 409.4 0.50001C409 0.70001 405.4 2.50001 403.1 3.60001C402.4 3.90001 402 4.60001 402 5.40001V53.7C402 54.8 402 54 402 56.5V93.9C402 94 402 94.1 402 94.2V97.8C402 98.9 402 98.1 402 100.6H411.4C413.4 100.6 415.1 98.7 415.1 96.6V94.5C415.1 94.3 415.2 94.1 415.2 93.9"
            fill="white"
        />
        <path
            d="M597.6 52.7C597.6 52.6 597.5 52.5 597.5 52.3C597.4 52 597.4 51.6 597.3 51.3C597.3 51.2 597.2 51.1 597.2 51C597.2 50.9 597.1 50.8 597.1 50.7C596.6 49.1 596.1 47.5 595.4 46C595 45.1 593.8 44.8 593 45.6L585.8 52.9L584.3 54.3C584.5 55.1 584.7 55.8 584.9 56.6C585.3 58.5 585.4 60.4 585.4 62.4C585.4 65 585.1 67.4 584.6 69.7H584.5C584 71.8 583.2 73.8 582.2 75.7C580.1 79.6 577.3 82.7 573.7 84.9C570.1 87.1 566.2 88.2 561.8 88.2C557.5 88.2 553.5 87.1 549.9 84.9C546.3 82.7 543.5 79.7 541.4 75.7C540.9 74.8 540.5 73.8 540.1 72.8C539.7 71.8 539.4 70.8 539.2 69.8C538.6 67.5 538.3 65 538.3 62.3C538.3 60.3 538.5 58.5 538.8 56.7C539.3 54 540.2 51.5 541.4 49.2C543.5 45.3 546.3 42.3 549.9 40.1C553.5 37.9 557.4 36.8 561.8 36.8C564.1 36.8 566.4 37.1 568.5 37.8L576.7 29.6C577.4 28.9 577.2 27.7 576.2 27.3C571.7 25.4 566.9 24.5 561.7 24.5C554.9 24.5 548.8 26.1 543.2 29.4C537.6 32.6 533.2 37.1 529.9 42.9C526.7 48.6 525 55.1 525 62.3C525 67.5 525.9 72.4 527.6 76.9C527.7 77.1 527.7 77.2 527.8 77.4C527.8 77.5 527.9 77.6 528 77.8C528.6 79.3 529.2 80.7 530 82C533.2 87.8 537.7 92.4 543.3 95.6C548.9 98.8 555.1 100.5 561.8 100.5C568.6 100.5 574.7 98.9 580.3 95.6C585.9 92.4 590.3 87.8 593.6 82C596.8 76.2 598.5 69.6 598.5 62.4C598.7 59 598.3 55.8 597.6 52.7Z"
            fill="white"
        />
        <path
            d="M143.1 72.1C143.1 71.9 143.2 71.7 143.2 71.5C143.7 69 143.9 66.4 143.9 63.6C143.9 56.4 142.3 49.9 139 44.2C135.8 38.5 131.3 34 125.7 30.7C120.1 27.5 113.9 25.8 107.2 25.8C102 25.8 97.2 26.7 92.7 28.6C92.6 28.7 92.5 28.7 92.4 28.8C91.1 29.4 89.8 30 88.6 30.7C83 33.9 78.6 38.4 75.3 44.2C74.7 45.2 74.3 46.2 73.8 47.2V47.3C71.6 52.2 70.5 57.7 70.5 63.6C70.5 68.8 71.4 73.7 73.1 78.2C73.2 78.4 73.2 78.5 73.3 78.7C73.3 78.8 73.4 78.9 73.5 79.1C74.1 80.6 74.7 82 75.5 83.3C78.7 89.1 83.2 93.7 88.8 96.9C94.4 100.1 100.6 101.8 107.3 101.8C114.1 101.8 120.2 100.2 125.8 96.9C131.4 93.7 135.8 89.1 139.1 83.3C140.8 80.2 142.1 76.8 142.9 73.3C142.9 73 143 72.5 143.1 72.1ZM95.4 41.5C99 39.3 102.9 38.2 107.3 38.2C109.6 38.2 111.9 38.5 114 39.2L114.1 39.1C115.9 39.6 117.6 40.4 119.2 41.4C122.8 43.6 125.6 46.6 127.7 50.5C128.6 52.1 129.2 53.8 129.7 55.6C129.9 56.4 130.1 57.1 130.3 57.9C130.7 59.8 130.8 61.7 130.8 63.7C130.8 65.9 130.6 68.1 130.2 70.1C130.1 70.4 130.1 70.7 130 71C129.5 73.1 128.7 75.1 127.7 77C126.7 78.9 125.5 80.7 124.1 82.2C122.7 83.7 121.1 85 119.3 86.1C115.7 88.3 111.8 89.4 107.4 89.4C103 89.4 99.1 88.3 95.5 86.1C91.9 84 89 81 86.9 77C85.9 75.1 85.2 73.1 84.6 71H84.5C83.9 68.7 83.7 66.3 83.7 63.7C83.7 61.7 83.9 59.9 84.2 58.1C84.2 58 84.2 58 84.2 57.9C84.2 57.8 84.2 57.8 84.2 57.7C84.3 57.3 84.4 56.9 84.5 56.5C84.6 56.2 84.6 56 84.7 55.7C85.2 53.9 85.9 52.2 86.7 50.6C89 46.7 91.8 43.7 95.4 41.5Z"
            fill="white"
        />
        <path
            d="M437.4 70.7L457.1 49.3C457.2 49.2 462.3 43.7 464 41.9L457.1 35.3C455.6 33.9 453.1 34.1 451.7 35.7C451.7 35.7 447.6 40.1 447.4 40.2L424.3 64.7C424.2 64.8 424 65 423.9 65.2C422.7 66.5 421.2 68 421.2 68C419.7 69.5 419.6 72 421.1 73.4L426.2 78.4L427.2 79.3L443.5 95.1C443.7 95.2 447.9 99.4 447.9 99.4C449.4 100.9 451.9 101 453.3 99.5L459.9 92.6C458.1 90.9 452.8 85.6 452.7 85.5L437.4 70.7Z"
            fill="#CF1327"
        />
        <path
            d="M582.4 47.8C585.99 47.8 588.9 44.8899 588.9 41.3C588.9 37.7102 585.99 34.8 582.4 34.8C578.81 34.8 575.9 37.7102 575.9 41.3C575.9 44.8899 578.81 47.8 582.4 47.8Z"
            fill="#CF1327"
        />
    </svg>
);
